var lang = {
	"Consumers": {
		"text": "Consommateurs",
		"isAlreadyTranslated": true
	},
	"Clear Search": {
		"text": "Effacer la recherche",
		"isAlreadyTranslated": true
	},
	"Filter Consumer": {
		"text": "Filtrer le consommateur",
		"isAlreadyTranslated": true
	},
	"Add Consumers": {
		"text": "Ajouter des consommateurs",
		"isAlreadyTranslated": true
	},
	"Name": {
		"text": "prénom",
		"isAlreadyTranslated": true
	},
	"Email ID": {
		"text": "Identifiant de courrier électronique",
		"isAlreadyTranslated": true
	},
	"Mobile": {
		"text": "Mobile",
		"isAlreadyTranslated": true
	},
	"Device Type": {
		"text": "Type 'appareil",
		"isAlreadyTranslated": true
	},
	"Consumer Details": {
		"text": "Détails du consommateur",
		"isAlreadyTranslated": true
	},
	"Mobile No.": {
		"text": "N ° mobile",
		"isAlreadyTranslated": true
	},
	"Model": {
		"text": "Modèle",
		"isAlreadyTranslated": true
	},
	"Alternate No.": {
		"text": "Autre numéro",
		"isAlreadyTranslated": true
	},
	"Landline No": {
		"text": "Numéro fixe",
		"isAlreadyTranslated": true
	},
	"View Consumer": {
		"text": "Voir le consommateur",
		"isAlreadyTranslated": true
	},
	"Save": {
		"text": "sauvegarder",
		"isAlreadyTranslated": true
	},
	"Issues": {
		"text": "Problèmes",
		"isAlreadyTranslated": true
	},
	"Add": {
		"text": "Ajouter",
		"isAlreadyTranslated": true
	},
	"Send": {
		"text": "Envoyer",
		"isAlreadyTranslated": true
	},
	"SMS": {
		"text": "SMS",
		"isAlreadyTranslated": true
	},
	"Email": {
		"text": "Email",
		"isAlreadyTranslated": true
	},
	"First": {
		"text": "Premier",
		"isAlreadyTranslated": true
	},
	"Last": {
		"text": "Dernier",
		"isAlreadyTranslated": true
	},
	"Filter": {
		"text": "Filtre",
		"isAlreadyTranslated": true
	},
	"Customer": {
		"text": "Client",
		"isAlreadyTranslated": true
	},
	"Close": {
		"text": "Fermer",
		"isAlreadyTranslated": true
	},
	"Call": {
		"text": "Appel",
		"isAlreadyTranslated": true
	},
	"logs": {
		"text": "journaux",
		"isAlreadyTranslated": true
	},
	"Consumer": {
		"text": "Consommateur",
		"isAlreadyTranslated": true
	},
	"Subcategory": {
		"text": "Sous-catégorie",
		"isAlreadyTranslated": true
	},
	"Brand": {
		"text": "Marque",
		"isAlreadyTranslated": true
	},
	"Product": {
		"text": "Produit",
		"isAlreadyTranslated": true
	},
	"Apply": {
		"text": "Appliquer",
		"isAlreadyTranslated": true
	},
	"Dashboard": {
		"text": "Tableau de bord",
		"isAlreadyTranslated": true
	},
	"Requests": {
		"text": "Requêtes",
		"isAlreadyTranslated": true
	},
	"View Document": {
		"text": "Voir le document",
		"isAlreadyTranslated": true
	},
	"Logout": {
		"text": "Connectez - Out",
		"isAlreadyTranslated": true
	},
	"Notifications": {
		"text": "Notifications",
		"isAlreadyTranslated": true
	},
	"Coupons": {
		"text": "Coupons",
		"isAlreadyTranslated": true
	},
	"UserList": {
		"text": "Liste 'utilisateur",
		"isAlreadyTranslated": true
	},
	"Curate": {
		"text": "Vicaire",
		"isAlreadyTranslated": true
	},
	"Diagnosis": {
		"text": "Diagnostic",
		"isAlreadyTranslated": true
	},
	"Distributor": {
		"text": "Distributeur",
		"isAlreadyTranslated": true
	},
	"Enterprise Sales": {
		"text": "Ventes 'entreprise",
		"isAlreadyTranslated": true
	},
	"Reseller": {
		"text": "Revendeur",
		"isAlreadyTranslated": true
	},
	"Plan Management": {
		"text": "Gestion de plan",
		"isAlreadyTranslated": true
	},
	"Sell Plans": {
		"text": "Vendre des plans",
		"isAlreadyTranslated": true
	},
	"Partner Management": {
		"text": "Gestion des partenaires",
		"isAlreadyTranslated": true
	},
	"Logistics Requests": {
		"text": "Demandes logistiques",
		"isAlreadyTranslated": true
	},
	"Optin Requests": {
		"text": "Requêtes Optin",
		"isAlreadyTranslated": true
	},
	"Catalogue": {
		"text": "Catalogue",
		"isAlreadyTranslated": true
	},
	"Exclusive": {
		"text": "Exclusif",
		"isAlreadyTranslated": true
	},
	"Created on": {
		"text": "Créé sur",
		"isAlreadyTranslated": true
	},
	"Source": {
		"text": "La source",
		"isAlreadyTranslated": true
	},
	"Device Count": {
		"text": "Nombre de périphériques",
		"isAlreadyTranslated": true
	},
	"Reg/Unreg": {
		"text": "Reg / Unreg",
		"isAlreadyTranslated": true
	},
	"Phone Number": {
		"text": "Numéro de téléphone",
		"isAlreadyTranslated": true
	},
	"View": {
		"text": "Vue",
		"isAlreadyTranslated": true
	},
	"Mobile No": {
		"text": "Mobile Non",
		"isAlreadyTranslated": true
	},
	"Cancel": {
		"text": "Annuler",
		"isAlreadyTranslated": true
	},
	"Edit": {
		"text": "modifier",
		"isAlreadyTranslated": true
	},
	"View Request": {
		"text": "Voir la demande",
		"isAlreadyTranslated": true
	},
	"Raise A Request": {
		"text": "Faire une demande",
		"isAlreadyTranslated": true
	},
	"Bills/Documents": {
		"text": "Projets de loi / documents",
		"isAlreadyTranslated": true
	},
	"Explore Device Lifecycle": {
		"text": "Explorer le cycle de vie des périphériques",
		"isAlreadyTranslated": true
	},
	"History": {
		"text": "Histoire",
		"isAlreadyTranslated": true
	},
	"Warranty Till": {
		"text": "Garantie jusqu'à",
		"isAlreadyTranslated": true
	},
	"Year Of Purchase": {
		"text": "Année 'achat",
		"isAlreadyTranslated": true
	},
	"Date Of Purchase": {
		"text": "Date 'achat",
		"isAlreadyTranslated": true
	},
	"IMEI": {
		"text": "IMEI",
		"isAlreadyTranslated": true
	},
	"Serial No.:": {
		"text": "Numéro de série.:",
		"isAlreadyTranslated": true
	},
	"Initiate diagnosis": {
		"text": "Lancer le diagnostic",
		"isAlreadyTranslated": true
	},
	"Initiate diagnosis directly in the Servify App": {
		"text": "Lancer le diagnostic directement dans l'application Servify",
		"isAlreadyTranslated": true
	},
	"No diagnosis performed": {
		"text": "Aucun diagnostic effectué",
		"isAlreadyTranslated": true
	},
	"View Diagnostic Result": {
		"text": "Afficher le résultat du diagnostic",
		"isAlreadyTranslated": true
	},
	"Last Diagnosis Performed on": {
		"text": "Dernier diagnostic effectué sur",
		"isAlreadyTranslated": true
	},
	"No Issues Found": {
		"text": "Aucun problème n'a été trouvé",
		"isAlreadyTranslated": true
	},
	"Found": {
		"text": "A trouvé",
		"isAlreadyTranslated": true
	},
	"Issue": {
		"text": "Problème",
		"isAlreadyTranslated": true
	},
	"Created Date": {
		"text": "Date de création",
		"isAlreadyTranslated": true
	},
	"Model No": {
		"text": "Modèle No",
		"isAlreadyTranslated": true
	},
	"Tag Name": {
		"text": "Nom du tag",
		"isAlreadyTranslated": true
	},
	"Product Subcategory": {
		"text": "Sous-catégorie de produits",
		"isAlreadyTranslated": true
	},
	"Add Product": {
		"text": "Ajouter un produit",
		"isAlreadyTranslated": true
	},
	"Upload Documents": {
		"text": "Télécharger des documents",
		"isAlreadyTranslated": true
	},
	"Serial No": {
		"text": "Numéro de série",
		"isAlreadyTranslated": true
	},
	"Product Name": {
		"text": "Nom du produit",
		"isAlreadyTranslated": true
	},
	"Product SubCategory": {
		"text": "Sous-catégorie de produit",
		"isAlreadyTranslated": true
	},
	"Loading": {
		"text": "Chargement",
		"isAlreadyTranslated": true
	},
	"Created On": {
		"text": "Créé sur",
		"isAlreadyTranslated": true
	},
	"Alternate Mobile No": {
		"text": "Autre numéro de mobile",
		"isAlreadyTranslated": true
	},
	"View Consumer Details": {
		"text": "Voir les détails du consommateur",
		"isAlreadyTranslated": true
	},
	"Call History": {
		"text": "Historique des appels",
		"isAlreadyTranslated": true
	},
	"Unregistered Products": {
		"text": "Produits non enregistrés",
		"isAlreadyTranslated": true
	},
	"Registered Products": {
		"text": "Produits enregistrés",
		"isAlreadyTranslated": true
	},
	"No unregistered products found": {
		"text": "Aucun produit non enregistré trouvé",
		"isAlreadyTranslated": true
	},
	"Content": {
		"text": "Contenu",
		"isAlreadyTranslated": true
	},
	"Customer Name": {
		"text": "Nom du client",
		"isAlreadyTranslated": true
	},
	"Reference ID": {
		"text": "Pièce 'identité",
		"isAlreadyTranslated": true
	},
	"Device": {
		"text": "Dispositif",
		"isAlreadyTranslated": true
	},
	"Status": {
		"text": "Statut",
		"isAlreadyTranslated": true
	},
	"Scheduled Date": {
		"text": "Date prévue",
		"isAlreadyTranslated": true
	},
	"Type": {
		"text": "Type",
		"isAlreadyTranslated": true
	},
	"Add call log": {
		"text": "Ajouter un journal 'appel",
		"isAlreadyTranslated": true
	},
	"Call type": {
		"text": "Type 'appel",
		"isAlreadyTranslated": true
	},
	"Connect": {
		"text": "Relier",
		"isAlreadyTranslated": true
	},
	"Non-Connect Disposition": {
		"text": "Disposition non connectée",
		"isAlreadyTranslated": true
	},
	"Connect Disposition": {
		"text": "Connecter la disposition",
		"isAlreadyTranslated": true
	},
	"Name of the caller": {
		"text": "Nom de l'appelant",
		"isAlreadyTranslated": true
	},
	"Remarks": {
		"text": "Remarques",
		"isAlreadyTranslated": true
	},
	"No call history": {
		"text": "Aucun historique 'appel",
		"isAlreadyTranslated": true
	},
	"Please enter alphabets only": {
		"text": "Veuillez entrer les alphabets seulement",
		"isAlreadyTranslated": true
	},
	"Please enter correct EmailID": {
		"text": "Veuillez entrer le bon EmailID",
		"isAlreadyTranslated": true
	},
	"Please enter correct Name": {
		"text": "Veuillez entrer le nom correct",
		"isAlreadyTranslated": true
	},
	"Please enter correct Alternate Mobile Number": {
		"text": "Veuillez entrer le bon numéro de mobile alternatif",
		"isAlreadyTranslated": true
	},
	"Incoming": {
		"text": "Entrant",
		"isAlreadyTranslated": true
	},
	"Outgoing": {
		"text": "Sortant",
		"isAlreadyTranslated": true
	},
	"Yes": {
		"text": "Oui",
		"isAlreadyTranslated": true
	},
	"No": {
		"text": "Non",
		"isAlreadyTranslated": true
	},
	"Call history": {
		"text": "Historique des appels",
		"isAlreadyTranslated": true
	},
	"No Data Available": {
		"text": "Pas de données disponibles",
		"isAlreadyTranslated": true
	},
	"Select a model": {
		"text": "Sélectionnez un modèle",
		"isAlreadyTranslated": true
	},
	"Customer Alternate Mobile No": {
		"text": "Client Autre mobile Non",
		"isAlreadyTranslated": true
	},
	"Incident ID": {
		"text": "ID de l'incident",
		"isAlreadyTranslated": true
	},
	"Select an issue": {
		"text": "Sélectionnez un problème",
		"isAlreadyTranslated": true
	},
	"Please enter Customer's Name": {
		"text": "Veuillez entrer le nom du client",
		"isAlreadyTranslated": true
	},
	"Please select a model from the dropdown": {
		"text": "Veuillez sélectionner un modèle dans le menu déroulant",
		"isAlreadyTranslated": true
	},
	"Please enter at least one issue": {
		"text": "Veuillez entrer au moins un problème",
		"isAlreadyTranslated": true
	},
	"Please select a Device Type": {
		"text": "Veuillez sélectionner un type de périphérique",
		"isAlreadyTranslated": true
	},
	"Please enter Mobile Number": {
		"text": "S'il vous plaît entrer le numéro de téléphone",
		"isAlreadyTranslated": true
	},
	"Please enter correct Mobile Number": {
		"text": "Veuillez entrer le bon numéro de mobile",
		"isAlreadyTranslated": true
	},
	"Please enter correct E-mail ID": {
		"text": "Veuillez entrer le bon E-mail ID",
		"isAlreadyTranslated": true
	},
	"Something went wrong": {
		"text": "Quelque chose s'est mal passé",
		"isAlreadyTranslated": true
	},
	"Consumer successfully added and SMS sent": {
		"text": "Consommateur ajouté avec succès et SMS envoyés",
		"isAlreadyTranslated": true
	},
	"Something went wrong when trying to create a consumer. Please try again": {
		"text": "Une erreur s'est produite lors de la création 'un consommateur. Veuillez réessayer",
		"isAlreadyTranslated": true
	},
	"You have already added this issue type": {
		"text": "Vous avez déjà ajouté ce type de problème",
		"isAlreadyTranslated": true
	},
	"Please select a Product from the dropdown": {
		"text": "Veuillez sélectionner une marque dans le menu déroulant",
		"isAlreadyTranslated": true
	},
	"Please select a Brand from the dropdown": {
		"text": "Veuillez sélectionner une sous-catégorie dans le menu déroulant",
		"isAlreadyTranslated": true
	},
	"Please select a Subcategory from the dropdown": {
		"text": "Choisissez une année entre",
		"isAlreadyTranslated": true
	},
	"Select a year between": {
		"text": "et",
		"isAlreadyTranslated": true
	},
	"and": {
		"text": "Veuillez sélectionner un type de document",
		"isAlreadyTranslated": true
	},
	"Please select a document type": {
		"text": "Veuillez sélectionner un document",
		"isAlreadyTranslated": true
	},
	"Please select a document": {
		"text": "Oups ... Quelque chose s'est mal passé",
		"isAlreadyTranslated": true
	},
	"Oops... Something went wrong": {
		"text": "Le produit a été ajouté",
		"isAlreadyTranslated": true
	},
	"No requests found": {
		"text": "Aucune demande trouvée",
		"isAlreadyTranslated": true
	},
	"OK": {
		"text": "D'accord",
		"isAlreadyTranslated": true
	},
	"Cancel": {
		"text": "Annuler",
		"isAlreadyTranslated": true
	},
	"REQUESTS": {
		"text": "Demande de réclamation",
		"isAlreadyTranslated": true
	},
	"Claim Request": {
		"text": "En cours",
		"isAlreadyTranslated": true
	},
	"In Progress": {
		"text": "Fermé",
		"isAlreadyTranslated": true
	},
	"Closed": {
		"text": "Annulé",
		"isAlreadyTranslated": true
	},
	"Cancelled": {
		"text": "Annulé",
		"isAlreadyTranslated": true
	},
	"Open": {
		"text": "Ouvrir",
		"isAlreadyTranslated": true
	},
	"Period": {
		"text": "Période",
		"isAlreadyTranslated": true
	},
	"Filter Requests": {
		"text": "Créer une demande en bloc",
		"isAlreadyTranslated": true
	},
	"Create Bulk Request": {
		"text": "Faire une demande",
		"isAlreadyTranslated": true
	},
	"Raise a request": {
		"text": "Demandes externes",
		"isAlreadyTranslated": true
	},
	"External Requests": {
		"text": "Queue de pièces",
		"isAlreadyTranslated": true
	},
	"Parts Queue": {
		"text": "Chargement des demandes",
		"isAlreadyTranslated": true
	},
	"Loading requests": {
		"text": "Client",
		"isAlreadyTranslated": true
	},
	"Customer": {
		"text": "Type de service",
		"isAlreadyTranslated": true
	},
	"Service type": {
		"text": "Programme",
		"isAlreadyTranslated": true
	},
	"Schedule": {
		"text": "Créé",
		"isAlreadyTranslated": true
	},
	"Download requests in csv format": {
		"text": "Télécharger les demandes en format csv",
		"isAlreadyTranslated": true
	},
	"Created": {
		"text": "Créé",
		"isAlreadyTranslated": true
	},
	"Customer": {
		"text": "Client",
		"isAlreadyTranslated": true
	},
	"Show graph": {
		"text": "Afficher le graphique",
		"isAlreadyTranslated": true
	},
	"Hide graph": {
		"text": "Masquer le graphique",
		"isAlreadyTranslated": true
	},
	"View": {
		"text": "Vue",
		"isAlreadyTranslated": true
	},
	"out of": {
		"text": "hors de",
		"isAlreadyTranslated": true
	},
	"service requests are shown above.": {
		"text": "les demandes de service sont indiquées ci-dessus.",
		"isAlreadyTranslated": true
	},
	"Created or found consumer": {
		"text": "Créateur créé ou trouvé",
		"isAlreadyTranslated": true
	},
	"Not updated": {
		"text": "Non mis à jour",
		"isAlreadyTranslated": true
	},
	"Not Updated": {
		"text": "Non mis à jour",
		"isAlreadyTranslated": true
	},
	"Please select a call disposition": {
		"text": "Veuillez sélectionner une disposition d'appel",
		"isAlreadyTranslated": true
	},
	"Please enter a name": {
		"text": "S'il vous plaît entrer un nom",
		"isAlreadyTranslated": true
	},
	"Please enter remarks": {
		"text": "S'il vous plaît entrer des remarques",
		"isAlreadyTranslated": true
	},
	"Username": {
		"text": "Nom d'utilisateur",
		"isAlreadyTranslated": true
	},
	"Call Connected": {
		"text": "Appelez connecté",
		"isAlreadyTranslated": true
	},
	"No": {
		"text": "Non",
		"isAlreadyTranslated": true
	},
	"Yes": {
		"text": "Oui",
		"isAlreadyTranslated": true
	},
	"Connection Disposition:": {
		"text": "Disposition de connexion:",
		"isAlreadyTranslated": true
	},
	"Non-Connect Disposition:": {
		"text": "Disposition non connectée:",
		"isAlreadyTranslated": true
	},
	"Date and Time of loss/Damage": {
		"text": "Date et heure de la perte / dommage",
		"isAlreadyTranslated": true
	},
	"Damage Type": {
		"text": "Type de dommage",
		"isAlreadyTranslated": true
	},
	"Description of Loss/Damage": {
		"text": "Description de la perte / dommage",
		"isAlreadyTranslated": true
	},
	"Date and Time of Call": {
		"text": "Date et heure de l'appel",
		"isAlreadyTranslated": true
	},
	"Status at which call was made": {
		"text": "Statut auquel l'appel a été effectué",
		"isAlreadyTranslated": true
	},
	"Remarks": {
		"text": "Remarques",
		"isAlreadyTranslated": true
	},
	"BER Refund": {
		"text": "Remboursement BER",
		"isAlreadyTranslated": true
	},
	"Service Center": {
		"text": "Centre de services",
		"isAlreadyTranslated": true
	},
	"Role": {
		"text": "Rôle",
		"isAlreadyTranslated": true
	},
	"Accessories will not be returned": {
		"text": "Les accessoires ne seront pas retournés",
		"isAlreadyTranslated": true
	},
	"Documents are yet to be uploaded": {
		"text": "Les documents doivent encore être téléchargés",
		"isAlreadyTranslated": true
	},
	"Request Scheduled for": {
		"text": "Demande prévue pour",
		"isAlreadyTranslated": true
	},
	"Slot": {
		"text": "Fente",
		"isAlreadyTranslated": true
	},
	"Action Status": {
		"text": "Statut de l'action",
		"isAlreadyTranslated": true
	},
	"Action taken": {
		"text": "Action prise",
		"isAlreadyTranslated": true
	},
	"Current Log": {
		"text": "Journal actuel",
		"isAlreadyTranslated": true
	},
	"Rating": {
		"text": "Évaluation",
		"isAlreadyTranslated": true
	},
	"Next Steps": {
		"text": "Prochaines étapes",
		"isAlreadyTranslated": true
	},
	"Waiting for the customer to raise a request": {
		"text": "Attendre que le client fasse une demande",
		"isAlreadyTranslated": true
	},
	"Cancel Request": {
		"text": "Demande d'annulation",
		"isAlreadyTranslated": true
	},
	"Cancel Service Without Dispatch": {
		"text": "Annuler le service sans envoi",
		"isAlreadyTranslated": true
	},
	"Device shipped": {
		"text": "Appareil expédié",
		"isAlreadyTranslated": true
	},
	"Reschedule": {
		"text": "Reporter",
		"isAlreadyTranslated": true
	},
	"Reassign": {
		"text": "Réaffecter",
		"isAlreadyTranslated": true
	},
	"Mark Customer Arrival": {
		"text": "Marquer l'arrivée du client",
		"isAlreadyTranslated": true
	},
	"Start Repair": {
		"text": "Démarrer la réparation",
		"isAlreadyTranslated": true
	},
	"Device Received": {
		"text": "Appareil reçu",
		"isAlreadyTranslated": true
	},
	"Generate Invoice": {
		"text": "Générer une facture",
		"isAlreadyTranslated": true
	},
	"Complete Repair": {
		"text": "Réparation complète",
		"isAlreadyTranslated": true
	},
	"Dispatch Device": {
		"text": "Dispatch Device",
		"isAlreadyTranslated": true
	},
	"Complete Service": {
		"text": "Service complet",
		"isAlreadyTranslated": true
	},
	"Cancel Repair": {
		"text": "Annuler la réparation",
		"isAlreadyTranslated": true
	},
	"Cancel Service": {
		"text": "Annuler le service",
		"isAlreadyTranslated": true
	},
	"Parts Pending": {
		"text": "Pièces en attente",
		"isAlreadyTranslated": true
	},
	"Parts received": {
		"text": "Pièces reçues",
		"isAlreadyTranslated": true
	},
	"Download Logistics Label": {
		"text": "Télécharger le label de logistique",
		"isAlreadyTranslated": true
	},
	"Download Jobsheet Label": {
		"text": "Télécharger l'étiquette de la feuille de travail",
		"isAlreadyTranslated": true
	},
	"Consumer Details": {
		"text": "Détails du consommateur",
		"isAlreadyTranslated": true
	},
	"Address Details": {
		"text": "Détails de l'adresse",
		"isAlreadyTranslated": true
	},
	"Raise Request": {
		"text": "Élever une demande",
		"isAlreadyTranslated": true
	},
	"Device Details": {
		"text": "DÉTAILS DE L'APPAREIL",
		"isAlreadyTranslated": true
	},
	"Request Documents": {
		"text": "Demande de documents",
		"isAlreadyTranslated": true
	},
	"Issue Validation": {
		"text": "Validation du problème",
		"isAlreadyTranslated": true
	},
	"Issues Reported": {
		"text": "Problèmes signalés",
		"isAlreadyTranslated": true
	},
	"Estimation Details": {
		"text": "Détails d'estimation",
		"isAlreadyTranslated": true
	},
	"Parts and Estimation": {
		"text": "Pièces et estimation",
		"isAlreadyTranslated": true
	},
	"Override Approval History": {
		"text": "Remplacer l'historique d'approbation",
		"isAlreadyTranslated": true
	},
	"Parts Requested": {
		"text": "Pièces demandées",
		"isAlreadyTranslated": true
	},
	"Other Requests": {
		"text": "Autres demandes",
		"isAlreadyTranslated": true
	},
	"Request Details": {
		"text": "Détails de la demande",
		"isAlreadyTranslated": true
	},
	"Logistics Details": {
		"text": "Détails de la logistique",
		"isAlreadyTranslated": true
	},
	"Communication History": {
		"text": "Histoire de la communication",
		"isAlreadyTranslated": true
	},
	"Communication history": {
		"text": "Histoire de la communication",
		"isAlreadyTranslated": true
	},
	"Override Approval": {
		"text": "Ignorer l'approbation",
		"isAlreadyTranslated": true
	},
	"Loading request": {
		"text": "Demande de chargement",
		"isAlreadyTranslated": true
	},
	"No such service request exists": {
		"text": "Aucune demande de service n'existe",
		"isAlreadyTranslated": true
	},
	"Please fill in the cancel reason before cancelling": {
		"text": "S'il vous plaît remplir le motif d'annulation avant d'annuler",
		"isAlreadyTranslated": true
	},
	"View Jobsheet": {
		"text": "Voir la feuille de travail",
		"isAlreadyTranslated": true
	},
	"Add required documents in 'Request Documents' section below": {
		"text": "Ajouter les documents requis dans la section «Demande de documents» ci-dessous",
		"isAlreadyTranslated": true
	},
	"Customer Details": {
		"text": "Détails du client",
		"isAlreadyTranslated": true
	},
	"Name": {
		"text": "prénom",
		"isAlreadyTranslated": true
	},
	"Mobile Number": {
		"text": "Numéro de portable",
		"isAlreadyTranslated": true
	},
	"Alternate Mobile No": {
		"text": "Autre numéro de mobile",
		"isAlreadyTranslated": true
	},
	"First Registered From": {
		"text": "Premier inscrit de",
		"isAlreadyTranslated": true
	},
	"Address Details": {
		"text": "Détails de l'adresse",
		"isAlreadyTranslated": true
	},
	"No saved Address": {
		"text": "Aucune adresse enregistrée",
		"isAlreadyTranslated": true
	},
	"Edit": {
		"text": "modifier",
		"isAlreadyTranslated": true
	},
	"Home": {
		"text": "Accueil",
		"isAlreadyTranslated": true
	},
	"Office": {
		"text": "Bureau",
		"isAlreadyTranslated": true
	},
	"Device": {
		"text": "Dispositif",
		"isAlreadyTranslated": true
	},
	"IMEI": {
		"text": "IMEI",
		"isAlreadyTranslated": true
	},
	"Serial Number": {
		"text": "Numéro de série",
		"isAlreadyTranslated": true
	},
	"Storage Capacity": {
		"text": "Capacité de stockage",
		"isAlreadyTranslated": true
	},
	"Warranty Status": {
		"text": "État de la garantie",
		"isAlreadyTranslated": true
	},
	"Out of Warranty": {
		"text": "Hors garantie",
		"isAlreadyTranslated": true
	},
	"Under warranty": {
		"text": "Sous garantie",
		"isAlreadyTranslated": true
	},
	"Warranty Till": {
		"text": "Garantie jusqu'à",
		"isAlreadyTranslated": true
	},
	"Insurance Status": {
		"text": "Statut d'assurance",
		"isAlreadyTranslated": true
	},
	"Insurer Name": {
		"text": "Nom de l'assureur",
		"isAlreadyTranslated": true
	},
	"Broker Name": {
		"text": "Nom du courtier",
		"isAlreadyTranslated": true
	},
	"Plan Name": {
		"text": "Nom du plan",
		"isAlreadyTranslated": true
	},
	"Distributor Name": {
		"text": "Nom du distributeur",
		"isAlreadyTranslated": true
	},
	"Retailer Name": {
		"text": "Nom du détaillant",
		"isAlreadyTranslated": true
	},
	"Type Of Program": {
		"text": "Type de programme",
		"isAlreadyTranslated": true
	},
	"Validity Text": {
		"text": "Texte de validité",
		"isAlreadyTranslated": true
	},
	"No. of Repairs Used": {
		"text": "Nombre de réparations utilisées",
		"isAlreadyTranslated": true
	},
	"No. of Repairs Allowed": {
		"text": "Nombre de réparations autorisées",
		"isAlreadyTranslated": true
	},
	"Year of Purchase": {
		"text": "Année d'achat",
		"isAlreadyTranslated": true
	},
	"Date of Purchase": {
		"text": "Date d'achat",
		"isAlreadyTranslated": true
	},
	"Purchase Price": {
		"text": "Prix ​​d'achat",
		"isAlreadyTranslated": true
	},
	"Is Warranty Applicable": {
		"text": "La garantie est-elle applicable",
		"isAlreadyTranslated": true
	},
	"Reason": {
		"text": "Raison",
		"isAlreadyTranslated": true
	},
	"Registration Documents": {
		"text": "Documents d'enregistrement",
		"isAlreadyTranslated": true
	},
	"Device Added Date": {
		"text": "Période de l'appareil ajouté",
		"isAlreadyTranslated": true
	},
	"GSX Validation Status": {
		"text": "Statut de validation GSX",
		"isAlreadyTranslated": true
	},
	"Validated": {
		"text": "Validé",
		"isAlreadyTranslated": true
	},
	"Not Validated": {
		"text": "Pas validé",
		"isAlreadyTranslated": true
	},
	"Verify": {
		"text": "Vérifier",
		"isAlreadyTranslated": true
	},
	"Please enter IMEI/serial number": {
		"text": "Veuillez entrer IMEI / numéro de série",
		"isAlreadyTranslated": true
	},
	"Please enter serial number": {
		"text": "S'il vous plaît entrer le numéro de série",
		"isAlreadyTranslated": true
	},
	"Please enter warranty till date": {
		"text": "Veuillez entrer la garantie jusqu'à la date",
		"isAlreadyTranslated": true
	},
	"Please upload a warranty supporting document": {
		"text": "Veuillez télécharger un document justificatif de garantie",
		"isAlreadyTranslated": true
	},
	"Please choose if the warranty is applicable or not": {
		"text": "Veuillez choisir si la garantie est applicable ou non",
		"isAlreadyTranslated": true
	},
	"Please enter the reason for warranty not being applicable": {
		"text": "Veuillez entrer le motif de la garantie non applicable",
		"isAlreadyTranslated": true
	},
	"Please select a document type": {
		"text": "Veuillez sélectionner un type de document",
		"isAlreadyTranslated": true
	},
	"Request Documents": {
		"text": "Demande de documents",
		"isAlreadyTranslated": true
	},
	"Remark": {
		"text": "Remarque",
		"isAlreadyTranslated": true
	},
	"No documents uploaded": {
		"text": "Aucun document téléchargé",
		"isAlreadyTranslated": true
	},
	"Add Pending Documents": {
		"text": "Ajouter des documents en attente",
		"isAlreadyTranslated": true
	},
	"No Pending Document Specified": {
		"text": "Aucun document en attente spécifié",
		"isAlreadyTranslated": true
	},
	"Add Additional Documents": {
		"text": "Ajouter des documents supplémentaires",
		"isAlreadyTranslated": true
	},
	"Something went wrong": {
		"text": "Quelque chose s'est mal passé",
		"isAlreadyTranslated": true
	},
	"Please select a document": {
		"text": "Veuillez sélectionner un document",
		"isAlreadyTranslated": true
	},
	"Issue Validation": {
		"text": "Validation du problème",
		"isAlreadyTranslated": true
	},
	"Consumer Raised Issues": {
		"text": "Problèmes soulevés par le consommateur",
		"isAlreadyTranslated": true
	},
	"Validate": {
		"text": "Valider",
		"isAlreadyTranslated": true
	},
	"Customer did not add issues": {
		"text": "Le client n'a pas ajouté de problèmes",
		"isAlreadyTranslated": true
	},
	"Add New Issues": {
		"text": "Ajouter de nouveaux problèmes",
		"isAlreadyTranslated": true
	},
	"No issues added": {
		"text": "Aucun problème ajouté",
		"isAlreadyTranslated": true
	},
	"Choose from dropdown list only": {
		"text": "Choisissez dans la liste déroulante seulement",
		"isAlreadyTranslated": true
	},
	"You have already added this issue": {
		"text": "Vous avez déjà ajouté ce problème",
		"isAlreadyTranslated": true
	},
	"Estimation Details": {
		"text": "Détails d'estimation",
		"isAlreadyTranslated": true
	},
	"Total Amount": {
		"text": "Montant total",
		"isAlreadyTranslated": true
	},
	"Total Payable": {
		"text": "Total à payer",
		"isAlreadyTranslated": true
	},
	"Covered Value": {
		"text": "Valeur couverte",
		"isAlreadyTranslated": true
	},
	"Send For Approval": {
		"text": "Envoyer pour approbation",
		"isAlreadyTranslated": true
	},
	"Advance cannot be greater than": {
		"text": "L'avance ne peut pas être supérieure à",
		"isAlreadyTranslated": true
	},
	"Discount cannot be greater than": {
		"text": "La remise ne peut pas être supérieure à",
		"isAlreadyTranslated": true
	},
	"Current Status": {
		"text": "Statut actuel",
		"isAlreadyTranslated": true
	},
	"Service Type": {
		"text": "type de service",
		"isAlreadyTranslated": true
	},
	"Schedule Date": {
		"text": "Date de programmation",
		"isAlreadyTranslated": true
	},
	"Reassigned": {
		"text": "Réaffecté",
		"isAlreadyTranslated": true
	},
	"Pickup Address": {
		"text": "Adresse de ramassage",
		"isAlreadyTranslated": true
	},
	"Address": {
		"text": "Adresse",
		"isAlreadyTranslated": true
	},
	"Landmark": {
		"text": "Point de repère",
		"isAlreadyTranslated": true
	},
	"Zipcode": {
		"text": "Code postal",
		"isAlreadyTranslated": true
	},
	"Under Warranty": {
		"text": "Sous garantie",
		"isAlreadyTranslated": true
	},
	"Warranty Applicable": {
		"text": "Garantie applicable",
		"isAlreadyTranslated": true
	},
	"Issue description": {
		"text": "Description du problème",
		"isAlreadyTranslated": true
	},
	"Customer's Version": {
		"text": "Version du client",
		"isAlreadyTranslated": true
	},
	"Telecon Version": {
		"text": "Version Telecon",
		"isAlreadyTranslated": true
	},
	"Green Rewards Chosen": {
		"text": "Récompenses vertes choisies",
		"isAlreadyTranslated": true
	},
	"Recycle Certificate": {
		"text": "Recycler le certificat",
		"isAlreadyTranslated": true
	},
	"Logistics - From Customer's Address To Servify Hub": {
		"text": "Logistique - De l'adresse du client à Servify Hub",
		"isAlreadyTranslated": true
	},
	"Logistics - From Customer's Address To Service Center": {
		"text": "Logistique - De l'adresse du client au centre de service",
		"isAlreadyTranslated": true
	},
	"Logistics - From Drop-Off Center to Servify Hub": {
		"text": "Logistique - Du centre de dépôt au centre Servify",
		"isAlreadyTranslated": true
	},
	"Logistics - From Servify Hub to Recycle Hub": {
		"text": "Logistique - De Servify Hub à Recycle Hub",
		"isAlreadyTranslated": true
	},
	"Logistics - Return to Customer": {
		"text": "Logistique - Retour au client",
		"isAlreadyTranslated": true
	},
	"Verification Code": {
		"text": "Code de vérification",
		"isAlreadyTranslated": true
	},
	"Waybill Number": {
		"text": "Numéro de bordereau",
		"isAlreadyTranslated": true
	},
	"Pick Up Confirmation Number": {
		"text": "Numéro de confirmation de ramassage",
		"isAlreadyTranslated": true
	},
	"Location": {
		"text": "Emplacement",
		"isAlreadyTranslated": true
	},
	"Pickup Charge": {
		"text": "Charge de ramassage",
		"isAlreadyTranslated": true
	},
	"Paid": {
		"text": "Payé",
		"isAlreadyTranslated": true
	},
	"Payable": {
		"text": "Payable",
		"isAlreadyTranslated": true
	},
	"Loss DateTime": {
		"text": "Loss DateTime",
		"isAlreadyTranslated": true
	},
	"Damage Type": {
		"text": "Type de dommage",
		"isAlreadyTranslated": true
	},
	"Loss Description": {
		"text": "Description de la perte",
		"isAlreadyTranslated": true
	},
	"Device switching on": {
		"text": "Dispositif allumé",
		"isAlreadyTranslated": true
	},
	"Place of Damage": {
		"text": "Lieu de Dommage",
		"isAlreadyTranslated": true
	},
	"Green Rewards": {
		"text": "Récompenses vertes",
		"isAlreadyTranslated": true
	},
	"Please enter issue description": {
		"text": "Veuillez entrer la description du problème",
		"isAlreadyTranslated": true
	},
	"Request History": {
		"text": "Demander l'historique",
		"isAlreadyTranslated": true
	},
	"Waiting for Assignment": {
		"text": "En attente d'affectation",
		"isAlreadyTranslated": true
	},
	"Document pending": {
		"text": "Document en attente",
		"isAlreadyTranslated": true
	},
	"BER confirmed": {
		"text": "BER confirmé",
		"isAlreadyTranslated": true
	},
	"BER approved": {
		"text": "BER approuvé",
		"isAlreadyTranslated": true
	},
	"BER identified": {
		"text": "BER identifié",
		"isAlreadyTranslated": true
	},
	"Claim estimation generated": {
		"text": "Estimation des réclamations générée",
		"isAlreadyTranslated": true
	},
	"Device received": {
		"text": "Appareil reçu",
		"isAlreadyTranslated": true
	},
	"Pickup Request Accepted": {
		"text": "Demande de ramassage acceptée",
		"isAlreadyTranslated": true
	},
	"In-principle approved": {
		"text": "En principe approuvé",
		"isAlreadyTranslated": true
	},
	"Claim initiated": {
		"text": "Revendication initiée",
		"isAlreadyTranslated": true
	},
	"Claim raised": {
		"text": "Demande soulevée",
		"isAlreadyTranslated": true
	},
	"We have received your claim request. Our representative will connect with you within the next 1-2 business days to process it further": {
		"text": "Nous avons reçu votre demande de réclamation. Notre représentant communiquera avec vous dans les 1-2 prochains jours ouvrables pour le traiter plus loin",
		"isAlreadyTranslated": true
	},
	"Device has been received by the service centre and is currently being diagnosed.": {
		"text": "Le périphérique a été reçu par le centre de service et est en cours de diagnostic.",
		"isAlreadyTranslated": true
	},
	"Looks like the repair cost is more than the depreciated value of your device. Please select the option you would like to proceed with.": {
		"text": "On dirait que le coût de réparation est supérieur à la valeur dépréciée de votre appareil. Veuillez sélectionner l'option que vous souhaitez utiliser.",
		"isAlreadyTranslated": true
	},
	"Carry in": {
		"text": "Transporter dans",
		"isAlreadyTranslated": true
	},
	"Assigned To": {
		"text": "Assigné à",
		"isAlreadyTranslated": true
	},
	"Assign": {
		"text": "Attribuer",
		"isAlreadyTranslated": true
	},
	"No service locations found": {
		"text": "Aucun emplacement de service trouvé",
		"isAlreadyTranslated": true
	},
	"Select a service center": {
		"text": "Sélectionnez un centre de service",
		"isAlreadyTranslated": true
	},
	"Service Engineer": {
		"text": "Technicien de maintenance",
		"isAlreadyTranslated": true
	},
	"No engineers found": {
		"text": "Aucun ingénieur trouvé",
		"isAlreadyTranslated": true
	},
	"Select an engineer": {
		"text": "Sélectionnez un ingénieur",
		"isAlreadyTranslated": true
	},
	"Request is being processed": {
		"text": "La demande est en cours de traitement",
		"isAlreadyTranslated": true
	},
	"ADD CHARGES": {
		"text": "AJOUTER DES CHARGES",
		"isAlreadyTranslated": true
	},
	"Amount": {
		"text": "Montant",
		"isAlreadyTranslated": true
	},
	"Other": {
		"text": "Autre",
		"isAlreadyTranslated": true
	},
	"Initiate Claim": {
		"text": "Lancer une réclamation",
		"isAlreadyTranslated": true
	},
	"Claim invalid": {
		"text": "Demande invalide",
		"isAlreadyTranslated": true
	},
	"Attempt Call": {
		"text": "Tentative d'appel",
		"isAlreadyTranslated": true
	},
	"Add Device Date of Purchase and Device Purchase Cost in 'Device Details' below": {
		"text": "Ajouter la date d'achat de l'appareil et le coût d'achat de l'appareil dans 'Détails de l'appareil' ci-dessous",
		"isAlreadyTranslated": true
	},
	"Ask for Documents Pending": {
		"text": "Demander des documents en attente",
		"isAlreadyTranslated": true
	},
	"Enter type of document to add": {
		"text": "Entrez le type de document à ajouter",
		"isAlreadyTranslated": true
	},
	"Enter Call Details": {
		"text": "Entrez les détails de l'appel",
		"isAlreadyTranslated": true
	},
	"Claim": {
		"text": "Prétendre",
		"isAlreadyTranslated": true
	},
	"Request History": {
		"text": "Demander l'historique",
		"isAlreadyTranslated": true
	},
	"Please enter Claim intimation number": {
		"text": "Veuillez entrer le numéro d'avis de réclamation",
		"isAlreadyTranslated": true
	},
	"Please enter Claim intimation number before submitting": {
		"text": "Veuillez entrer le numéro d'avis de réclamation avant de soumettre",
		"isAlreadyTranslated": true
	},
	"Download requests in csv format": {
		"text": "Télécharger les demandes en format csv",
		"isAlreadyTranslated": true
	},
	"Data displayed": {
		"text": "Données affichées",
		"isAlreadyTranslated": true
	},
	"from": {
		"text": "de",
		"isAlreadyTranslated": true
	},
	"till": {
		"text": "jusqu'à",
		"isAlreadyTranslated": true
	},
	"Reject Claim": {
		"text": "Rejeter une revendication",
		"isAlreadyTranslated": true
	},
	"Please upload a clear copy of cancelled cheque with the claimant (your) name on it.": {
		"text": "Veuillez télécharger une copie du chèque annulé avec le nom du demandeur (votre).",
		"isAlreadyTranslated": true
	},
	"Customer Mobile number": {
		"text": "Numéro de portable du client",
		"isAlreadyTranslated": true
	},
	"Customer Mobile Number": {
		"text": "Numéro de portable du client",
		"isAlreadyTranslated": true
	},
	"TRACK EXTERNAL REQUEST": {
		"text": "PISTE EXTERNE DEMANDE",
		"isAlreadyTranslated": true
	},
	"Oops... Something went wrong!": {
		"text": "Oups ... Quelque chose s'est mal passé!",
		"isAlreadyTranslated": true
	},
	"Edit": {
		"text": "modifier",
		"isAlreadyTranslated": true
	},
	"Add": {
		"text": "Ajouter",
		"isAlreadyTranslated": true
	},
	"an address": {
		"text": "une adresse",
		"isAlreadyTranslated": true
	},
	"Landmark": {
		"text": "Point de repère",
		"isAlreadyTranslated": true
	},
	"Address": {
		"text": "Adresse",
		"isAlreadyTranslated": true
	},
	"Pincode": {
		"text": "Code PIN",
		"isAlreadyTranslated": true
	},
	"Characters must be numbers": {
		"text": "Les caractères doivent être des nombres",
		"isAlreadyTranslated": true
	},
	"Clear": {
		"text": "Clair",
		"isAlreadyTranslated": true
	},
	"Cancel": {
		"text": "Annuler",
		"isAlreadyTranslated": true
	},
	"Save": {
		"text": "sauvegarder",
		"isAlreadyTranslated": true
	},
	"Please enter Landmark": {
		"text": "Veuillez entrer Landmark",
		"isAlreadyTranslated": true
	},
	"Please enter Customer's address": {
		"text": "Veuillez entrer l'adresse du client",
		"isAlreadyTranslated": true
	},
	"Please enter pincode": {
		"text": "Veuillez entrer le code PIN",
		"isAlreadyTranslated": true
	},
	"Enter correct Pincode": {
		"text": "Entrez le code Pincode correct",
		"isAlreadyTranslated": true
	},
	"Address updated successfully": {
		"text": "Adresse mise à jour avec succès",
		"isAlreadyTranslated": true
	},
	"Home": {
		"text": "Accueil",
		"isAlreadyTranslated": true
	},
	"Office": {
		"text": "Bureau",
		"isAlreadyTranslated": true
	},
	"Other": {
		"text": "Autre",
		"isAlreadyTranslated": true
	},
	"Documents Pending": {
		"text": "Documents en attente",
		"isAlreadyTranslated": true
	},
	"Date and Time of loss/damage": {
		"text": "Date et heure de la perte / dommage",
		"isAlreadyTranslated": true
	},
	"Select Damage Type": {
		"text": "Sélectionnez Type de dommage",
		"isAlreadyTranslated": true
	},
	"Description of loss/damage": {
		"text": "Description de la perte / dommage",
		"isAlreadyTranslated": true
	},
	"Please enter UTR Number": {
		"text": "Veuillez entrer le numéro UTR",
		"isAlreadyTranslated": true
	},
	"Payment Date": {
		"text": "Date de paiement",
		"isAlreadyTranslated": true
	},
	"UTR Number": {
		"text": "Numéro UTR",
		"isAlreadyTranslated": true
	},
	"Attempt Call": {
		"text": "Tentative d'appel",
		"isAlreadyTranslated": true
	},
	"Service Charge": {
		"text": "Frais de service",
		"isAlreadyTranslated": true
	},
	"SGST": {
		"text": "SGST",
		"isAlreadyTranslated": true
	},
	"CGST": {
		"text": "CGST",
		"isAlreadyTranslated": true
	},
	"TESTING": {
		"text": "ESSAI",
		"isAlreadyTranslated": true
	},
	"Mandatory deductible": {
		"text": "Déductible obligatoire",
		"isAlreadyTranslated": true
	},
	"Mandatorydeductible": {
		"text": "Obligatoire",
		"isAlreadyTranslated": true
	},
	"Admin fees": {
		"text": "Frais administratifs",
		"isAlreadyTranslated": true
	},
	"Claim amount": {
		"text": "Montant de la réclamation",
		"isAlreadyTranslated": true
	},
	"Adminfees": {
		"text": "Adminfees",
		"isAlreadyTranslated": true
	},
	"Advance payment": {
		"text": "Acompte",
		"isAlreadyTranslated": true
	},
	"Advance": {
		"text": "Avance",
		"isAlreadyTranslated": true
	},
	"Back to all requests": {
		"text": "Retour à toutes les demandes",
		"isAlreadyTranslated": true
	},
	"Alternate Mobile Number": {
		"text": "Autre numéro de mobile",
		"isAlreadyTranslated": true
	},
	"Please enter correct mobile Number": {
		"text": "S'il vous plaît entrer le numéro de téléphone correct",
		"isAlreadyTranslated": true
	},
	"Detail Description of Damage": {
		"text": "Détail Description des dommages",
		"isAlreadyTranslated": true
	},
	"Please Enter Minimum 75 Characters": {
		"text": "Veuillez entrer au moins 75 caractères",
		"isAlreadyTranslated": true
	},
	"Submit": {
		"text": "Soumettre",
		"isAlreadyTranslated": true
	},
	"Add an address": {
		"text": "Ajouter une adresse",
		"isAlreadyTranslated": true
	},
	"Select an Address": {
		"text": "Sélectionnez une adresse",
		"isAlreadyTranslated": true
	},
	"Add New Address": {
		"text": "Ajouter une nouvelle adresse",
		"isAlreadyTranslated": true
	},
	"No addresses found": {
		"text": "Aucune adresse trouvée",
		"isAlreadyTranslated": true
	},
	"Select a service location": {
		"text": "Sélectionnez un emplacement de service",
		"isAlreadyTranslated": true
	},
	"Oops! There are no verified service centres around": {
		"text": "Oops! Il n'y a aucun centre de service vérifié autour",
		"isAlreadyTranslated": true
	},
	"Service": {
		"text": "Un service",
		"isAlreadyTranslated": true
	},
	"Contact": {
		"text": "Contact",
		"isAlreadyTranslated": true
	},
	"Brand authorised": {
		"text": "Marque autorisée",
		"isAlreadyTranslated": true
	},
	"Distance from user": {
		"text": "Distance de l'utilisateur",
		"isAlreadyTranslated": true
	},
	"There is no service for this address at this moment": {
		"text": "Il n'y a pas de service pour cette adresse en ce moment",
		"isAlreadyTranslated": true
	},
	"Select a Date": {
		"text": "Sélectionnez une date",
		"isAlreadyTranslated": true
	},
	"Select a Slot": {
		"text": "Sélectionnez une fente",
		"isAlreadyTranslated": true
	},
	"No Slots Available": {
		"text": "Pas de machines à sous disponibles",
		"isAlreadyTranslated": true
	},
	"Select issues": {
		"text": "Sélectionnez les problèmes",
		"isAlreadyTranslated": true
	},
	"Cannot select more than": {
		"text": "Impossible de sélectionner plus de",
		"isAlreadyTranslated": true
	},
	"issues": {
		"text": "problèmes",
		"isAlreadyTranslated": true
	},
	"Select a Reward": {
		"text": "Choisissez une récompense",
		"isAlreadyTranslated": true
	},
	"Select Logistics Partner": {
		"text": "Sélectionnez un partenaire logistique",
		"isAlreadyTranslated": true
	},
	"Confirm": {
		"text": "Confirmer",
		"isAlreadyTranslated": true
	},
	"Mobile Number": {
		"text": "Numéro de portable",
		"isAlreadyTranslated": true
	},
	"Full name": {
		"text": "Nom complet",
		"isAlreadyTranslated": true
	},
	"Add a Product": {
		"text": "Ajouter un produit",
		"isAlreadyTranslated": true
	},
	"No servicable consumer product found": {
		"text": "Aucun produit de consommation réparable trouvé",
		"isAlreadyTranslated": true
	},
	"Select a Subcategory": {
		"text": "Sélectionnez une sous-catégorie",
		"isAlreadyTranslated": true
	},
	"Select a Brand": {
		"text": "Sélectionnez une marque",
		"isAlreadyTranslated": true
	},
	"Characters must be alphabets": {
		"text": "Les caractères doivent être des alphabets",
		"isAlreadyTranslated": true
	},
	"Search brands": {
		"text": "Rechercher des marques",
		"isAlreadyTranslated": true
	},
	"Select a Product": {
		"text": "Choisissez un produit",
		"isAlreadyTranslated": true
	},
	"Add Selected Product": {
		"text": "Ajouter le produit sélectionné",
		"isAlreadyTranslated": true
	},
	"Device In Warranty": {
		"text": "Dispositif en garantie",
		"isAlreadyTranslated": true
	},
	"Is Warranty Applicable for this request": {
		"text": "La garantie est-elle applicable à cette demande",
		"isAlreadyTranslated": true
	},
	"Select a Service Mode": {
		"text": "Sélectionnez un mode de service",
		"isAlreadyTranslated": true
	},
	"DAMAGE DETAILS": {
		"text": "DÉTAILS DES DOMMAGES",
		"isAlreadyTranslated": true
	},
	"When did your device get damaged?": {
		"text": "Quand votre appareil est-il endommagé?",
		"isAlreadyTranslated": true
	},
	"Please tell us how was your device damaged": {
		"text": "S'il vous plaît dites-nous comment votre appareil a-t-il été endommagé",
		"isAlreadyTranslated": true
	},
	"min 100 characters": {
		"text": "min 100 caractères",
		"isAlreadyTranslated": true
	},
	"Please Select Damage Date": {
		"text": "Veuillez sélectionner la date du dommage",
		"isAlreadyTranslated": true
	},
	"Time of Damage": {
		"text": "Temps de Dommage",
		"isAlreadyTranslated": true
	},
	"Select type of damage": {
		"text": "Sélectionnez le type de dommage",
		"isAlreadyTranslated": true
	},
	"Is your device switching ON": {
		"text": "Votre appareil est-il en marche",
		"isAlreadyTranslated": true
	},
	"Select a Consumer Product": {
		"text": "Sélectionnez un produit de consommation",
		"isAlreadyTranslated": true
	},
	"Date of Damage": {
		"text": "Date de Dommage",
		"isAlreadyTranslated": true
	},
	"Please Select Damage Date": {
		"text": "Veuillez sélectionner la date du dommage",
		"isAlreadyTranslated": true
	},
	"Time of Damage": {
		"text": "Temps de Dommage",
		"isAlreadyTranslated": true
	},
	"Select type of damage": {
		"text": "Sélectionnez le type de dommage",
		"isAlreadyTranslated": true
	},
	"Is your device switching ON": {
		"text": "Votre appareil est-il en marche",
		"isAlreadyTranslated": true
	},
	"Select a Consumer Product": {
		"text": "Sélectionnez un produit de consommation",
		"isAlreadyTranslated": true
	},
	"Characters must be numeric": {
		"text": "Les caractères doivent être numériques",
		"isAlreadyTranslated": true
	},
	"Characters must be alphabets (at least 2 alphabets are mandatory)": {
		"text": "Les caractères doivent être des alphabets (au moins 2 alphabets sont obligatoires)",
		"isAlreadyTranslated": true
	},
	"Invalid email id": {
		"text": "ID de courrier électronique non valide",
		"isAlreadyTranslated": true
	},
	"Search products": {
		"text": "Recherche de produits",
		"isAlreadyTranslated": true
	},
	"products under service": {
		"text": "produits en service",
		"isAlreadyTranslated": true
	},
	"Characters must be alphanumeric": {
		"text": "Les caractères doivent être alphanumériques",
		"isAlreadyTranslated": true
	},
	"Please Select Time": {
		"text": "Veuillez sélectionner l'heure",
		"isAlreadyTranslated": true
	},
	"Please Select Damage type": {
		"text": "Veuillez sélectionner le type de dommage",
		"isAlreadyTranslated": true
	},
	"Please Enter Place of Damage": {
		"text": "S'il vous plaît entrer Lieu de Dommage",
		"isAlreadyTranslated": true
	},
	"Please Select an option": {
		"text": "Veuillez sélectionner une option",
		"isAlreadyTranslated": true
	},
	"Min 75 Characters": {
		"text": "Min 75 caractères",
		"isAlreadyTranslated": true
	},
	"Consumer Name": {
		"text": "Nom du consommateur",
		"isAlreadyTranslated": true
	},
	"Contact No": {
		"text": "Pas de contact",
		"isAlreadyTranslated": true
	},
	"Logistics Provider": {
		"text": "Fournisseur de logistique",
		"isAlreadyTranslated": true
	},
	"Registration Source": {
		"text": "Source d'inscription",
		"isAlreadyTranslated": true
	},
	"Customer City": {
		"text": "Ville du client",
		"isAlreadyTranslated": true
	},
	"Call Type": {
		"text": "Type d'appel",
		"isAlreadyTranslated": true
	},
	"Re-apply": {
		"text": "Réappliquer",
		"isAlreadyTranslated": true
	},
	"something went wrong": {
		"text": "quelque chose a mal tourné",
		"isAlreadyTranslated": true
	},
	"Today": {
		"text": "Aujourd’hui",
		"isAlreadyTranslated": true
	},
	"Yesterday": {
		"text": "Hier",
		"isAlreadyTranslated": true
	},
	"Last 7 Days": {
		"text": "Les 7 derniers jours",
		"isAlreadyTranslated": true
	},
	"Last 30 Days": {
		"text": "Les 30 derniers jours",
		"isAlreadyTranslated": true
	},
	"This Month": {
		"text": "Ce mois-ci",
		"isAlreadyTranslated": true
	},
	"Last Month": {
		"text": "Le mois dernier",
		"isAlreadyTranslated": true
	},
	"Custom Range": {
		"text": "Gamme personnalisée",
		"isAlreadyTranslated": true
	},
	"Add Device Date of Purchase and Device Purchase Cost in 'Device Details' below": {
		"text": "Ajouter la date d'achat de l'appareil et le coût d'achat de l'appareil dans 'Détails de l'appareil' ci-dessous",
		"isAlreadyTranslated": true
	},
	"Add a part charge in 'Estimation Details' below to generate estimation": {
		"text": "Ajouter une charge partielle dans les 'Détails d'estimation' ci-dessous pour générer une estimation",
		"isAlreadyTranslated": true
	},
	"Enter Reference IDs": {
		"text": "Entrez les ID de référence",
		"isAlreadyTranslated": true
	},
	"Current Request Reference ID": {
		"text": "ID de référence de demande en cours",
		"isAlreadyTranslated": true
	},
	"Pick Up Request Reference ID": {
		"text": "ID de référence de demande de prise en charge",
		"isAlreadyTranslated": true
	},
	"Merge": {
		"text": "Fusionner",
		"isAlreadyTranslated": true
	},
	"Convert request": {
		"text": "Convertir la demande",
		"isAlreadyTranslated": true
	},
	"No Data Available To Plot The Graph": {
		"text": "Aucune donnée disponible pour tracer le graphique",
		"isAlreadyTranslated": true
	},
	"to": {
		"text": "à",
		"isAlreadyTranslated": true
	},
	"Download requests in csv format.": {
		"text": "Télécharger les demandes au format csv.",
		"isAlreadyTranslated": true
	},
	"Service cancelled": {
		"text": "Service annulé",
		"isAlreadyTranslated": true
	},
	"Mobile number": {
		"text": "Numéro de portable",
		"isAlreadyTranslated": true
	},
	"Characters must be numeric.": {
		"text": "Les caractères doivent être numériques.",
		"isAlreadyTranslated": true
	},
	"Search consumer products": {
		"text": "Rechercher des produits de consommation",
		"isAlreadyTranslated": true
	},
	"Search subcategories": {
		"text": "Rechercher des sous-catégories",
		"isAlreadyTranslated": true
	},
	"OR": {
		"text": "OU",
		"isAlreadyTranslated": true
	},
	"Enter IMEI or Serial Number": {
		"text": "Entrez IMEI ou numéro de série",
		"isAlreadyTranslated": true
	},
	"Serial number": {
		"text": "Numéro de série",
		"isAlreadyTranslated": true
	},
	"Selected Product": {
		"text": "Produit sélectionné",
		"isAlreadyTranslated": true
	},
	"IMEI Number": {
		"text": "Numéro IMEI",
		"isAlreadyTranslated": true
	},
	"Contract Type": {
		"text": "Type de contrat",
		"isAlreadyTranslated": true
	},
	"Warranty": {
		"text": "garantie",
		"isAlreadyTranslated": true
	},
	"Enter Serial Number": {
		"text": "Entrer le numéro de série",
		"isAlreadyTranslated": true
	},
	"Select Customer Type": {
		"text": "Sélectionnez le type de client",
		"isAlreadyTranslated": true
	},
	"Walk-in Customer": {
		"text": "Client Walk-in",
		"isAlreadyTranslated": true
	},
	"Future Appointment": {
		"text": "Prochain rendez-vous",
		"isAlreadyTranslated": true
	},
	"Oops! There are no verified service centres around.": {
		"text": "Oops! Il n'y a aucun centre de service vérifié autour.",
		"isAlreadyTranslated": true
	},
	"Search issues": {
		"text": "Rechercher des problèmes",
		"isAlreadyTranslated": true
	},
	"Mobile": {
		"text": "Mobile",
		"isAlreadyTranslated": true
	},
	"Tablet": {
		"text": "Tablette",
		"isAlreadyTranslated": true
	},
	"Computer": {
		"text": "Ordinateur",
		"isAlreadyTranslated": true
	},
	"Audio Product": {
		"text": "Produit audio",
		"isAlreadyTranslated": true
	},
	"Streaming Device": {
		"text": "Dispositif de streaming",
		"isAlreadyTranslated": true
	},
	"Smart Watch": {
		"text": "Montre intelligente",
		"isAlreadyTranslated": true
	},
	"Serial number is mandatory for Apple Products.\nPlease enter valid serial number": {
		"text": "Le numéro de série est obligatoire pour les produits Apple.Veuillez entrer un numéro de série valide",
		"isAlreadyTranslated": true
	},
	"Pickup Drop By": {
		"text": "Ramassage Drop By",
		"isAlreadyTranslated": true
	},
	"Requires customer to print documents and safely pack the device.": {
		"text": "Demande au client d'imprimer des documents et d'emballer l'appareil en toute sécurité.",
		"isAlreadyTranslated": true
	},
	"No parts requested": {
		"text": "Aucune pièce demandée",
		"isAlreadyTranslated": true
	},
	"Part Name": {
		"text": "Nom de la pièce",
		"isAlreadyTranslated": true
	},
	"Part Code": {
		"text": "Code de pièce",
		"isAlreadyTranslated": true
	},
	"Qty": {
		"text": "Qté",
		"isAlreadyTranslated": true
	},
	"Available Quantity": {
		"text": "quantité disponible",
		"isAlreadyTranslated": true
	},
	"Requested By": {
		"text": "Demandé par",
		"isAlreadyTranslated": true
	},
	"Issued By": {
		"text": "Délivré par",
		"isAlreadyTranslated": true
	},
	"Enter Information for the parts you are issuing": {
		"text": "Entrez les informations pour les pièces que vous publiez",
		"isAlreadyTranslated": true
	},
	"External Reference ID": {
		"text": "ID de référence externe",
		"isAlreadyTranslated": true
	},
	"Enter Reference ID": {
		"text": "Entrez l'ID de référence",
		"isAlreadyTranslated": true
	},
	"Device Value": {
		"text": "Valeur de l'appareil",
		"isAlreadyTranslated": true
	},
	"One time deductible": {
		"text": "Franchise unique",
		"isAlreadyTranslated": true
	},
	"Is Manufacturer's Warranty Applicable": {
		"text": "La garantie du fabricant est-elle applicable",
		"isAlreadyTranslated": true
	},
	"Manufacturer's Warranty Status": {
		"text": "Statut de Garantie du fabricant",
		"isAlreadyTranslated": true
	},
	"Add Device Date of Purchase and Device Value in 'Device Details' below": {
		"text": "Aggiungere la data di acquisto del dispositivo e il valore del dispositivo nei 'Dettagli del dispositivo' qui sotto.",
		"isAlreadyTranslated": true
	},
	"To proceed, update Device Date of Purchase and Device Value in 'Device Details' below.": {
		"text": "Per procedere, aggiornare la data di acquisto del dispositivo e il valore del dispositivo in 'Dettagli dispositivo' qui sotto.",
		"isAlreadyTranslated": true
	},
	"Log Call": {
		"text": "enregistrer un appel",
		"isAlreadyTranslated": true
	},
	"Please update Warranty applicable status in Device Details section.": {
		"text": "Veuillez mettre à jour le statut de la garantie applicable dans la section 'Détails du dispositif'.",
		"isAlreadyTranslated": true
	},
	"Customer Care Executive can Run Diagnosis, Inspect Device to log a hardware repair, Please update Warranty applicable status in Device Details section to enable Non Hardware Closure.": {
		"text": "Customer Care Executive peut exécuter un diagnostic, inspecter le dispositif pour enregistrer une réparation matérielle, mettre à jour le statut de la garantie applicable dans la section Détails du dispositif pour activer la fermeture non matérielle.",
		"isAlreadyTranslated": true
	},
	"Plan Validity": {
		"text": "Validité du plan",
		"isAlreadyTranslated": true
	},
	"Payment": {
		"text": "Paiement",
		"isAlreadyTranslated": true
	},
	"View Plans": {
		"text": "Voir les forfaits",
		"isAlreadyTranslated": true
	},
	"Agreement Number": {
		"text": "Numéro de contrat",
		"isAlreadyTranslated": true
	},
	"Customer Email ID": {
		"text": "Identifiant de messagerie du client",
		"isAlreadyTranslated": true
	},
	"Warranty End Date": {
		"text": "Date de fin de la garantie",
		"isAlreadyTranslated": true
	},
	"Sell now": {
		"text": "Vendre maintenant",
		"isAlreadyTranslated": true
	},
	"Sell Now": {
		"text": "Vendre maintenant",
		"isAlreadyTranslated": true
	},
	"Know more": {
		"text": "Savoir plus",
		"isAlreadyTranslated": true
	},
	"Know More": {
		"text": "Savoir plus",
		"isAlreadyTranslated": true
	},
	"Enter Mobile number/Email ID": {
		"text": "Entrez le numéro de mobile/l'identifiant de messagerie",
		"isAlreadyTranslated": true
	},
	"Enter Mobile Number": {
		"text": "Entrez le numéro de portable",
		"isAlreadyTranslated": true
	},
	"Active Plans": {
		"text": "Forfaits actifs",
		"isAlreadyTranslated": true
	},
	"valid till": {
		"text": "valable jusqu'au",
		"isAlreadyTranslated": true
	},
	"Coverage Start Date": {
		"text": "Date de début de la couverture",
		"isAlreadyTranslated": true
	},
	"Please select a reason for cancelling": {
		"text": "Veuillez sélectionner un motif d'annulation",
		"isAlreadyTranslated": true
	},
	"Communication Name": {
		"text": "Nom de la communication",
		"isAlreadyTranslated": true
	},
	"Communication Number": {
		"text": "Numéro de communication",
		"isAlreadyTranslated": true
	},
	"Communication EmailID": {
		"text": "ID de courrier électronique de communication",
		"isAlreadyTranslated": true
	},
	"Select brand": {
		"text": "Choisir une marque",
		"isAlreadyTranslated": true
	},
	"Customers": {
		"text": "Clients",
		"isAlreadyTranslated": true
	},
	"Consumer Mobile": {
		"text": "Mobile grand public",
		"isAlreadyTranslated": true
	},
	"Consumer Email": {
		"text": "E-mail du consommateur",
		"isAlreadyTranslated": true
	},
	"Serial Number/IMEI": {
		"text": "Numéro de série/IMEI",
		"isAlreadyTranslated": true
	},
	"Filter Consumers": {
		"text": "Filtrer les consommateurs",
		"isAlreadyTranslated": true
	},
	"IMEI/Serial Number": {
		"text": "IMEI/numéro de série",
		"isAlreadyTranslated": true
	},
	"Order Item ID": {
		"text": "Numéro d'article de la commande",
		"isAlreadyTranslated": true
	},
	"Order ID": {
		"text": "numéro de commande",
		"isAlreadyTranslated": true
	},
	"PLANS": {
		"text": "PLANS",
		"isAlreadyTranslated": true
	},
	"Exceptional Sales": {
		"text": "Ventes exceptionnelles",
		"isAlreadyTranslated": true
	},
	"Protect": {
		"text": "Protéger",
		"isAlreadyTranslated": true
	},
	"User list": {
		"text": "Liste des utilisateurs",
		"isAlreadyTranslated": true
	},
	"USER MANAGEMENT": {
		"text": "Gestion des utilisateurs",
		"isAlreadyTranslated": true
	},
	"Product Detail": {
		"text": "Détail du produit",
		"isAlreadyTranslated": true
	},
	"IMEI/Serial No": {
		"text": "IMEI/numéro de série",
		"isAlreadyTranslated": true
	},
	"Pick Up Detail": {
		"text": "Détails de ramassage",
		"isAlreadyTranslated": true
	},
	"Contact No.": {
		"text": "Numéro de contact",
		"isAlreadyTranslated": true
	},
	"Pin Code": {
		"text": "Code PIN",
		"isAlreadyTranslated": true
	},
	"City": {
		"text": "Ville",
		"isAlreadyTranslated": true
	},
	"State": {
		"text": "État",
		"isAlreadyTranslated": true
	},
	"Country": {
		"text": "Pays",
		"isAlreadyTranslated": true
	},
	"Drop Detail": {
		"text": "Déposer les détails",
		"isAlreadyTranslated": true
	},
	"Customer Mobile No:": {
		"text": "N° de mobile client :",
		"isAlreadyTranslated": true
	},
	"Customer Date of Birth": {
		"text": "Date de naissance du client",
		"isAlreadyTranslated": true
	},
	"Product Value:": {
		"text": "Valeur du produit :",
		"isAlreadyTranslated": true
	},
	"Final Plan Price": {
		"text": "Prix ​​du plan final",
		"isAlreadyTranslated": true
	},
	"Privacy Policy": {
		"text": "politique de confidentialité",
		"isAlreadyTranslated": true
	},
	"Payment Received": {
		"text": "Paiement reçu",
		"isAlreadyTranslated": true
	},
	"Invalid OTP": {
		"text": "OTP invalide",
		"isAlreadyTranslated": true
	},
	"Resend OTP": {
		"text": "Renvoyer OTP",
		"isAlreadyTranslated": true
	},
	"Maximum": {
		"text": "Maximum",
		"isAlreadyTranslated": true
	},
	"Characters Allowed": {
		"text": "caractères autorisés",
		"isAlreadyTranslated": true
	},
	"Congratulations!": {
		"text": "Félicitations!",
		"isAlreadyTranslated": true
	},
	"Successfully Purchased": {
		"text": "Acheté avec succès",
		"isAlreadyTranslated": true
	},
	"Sign in to continue.": {
		"text": "Connectez-vous pour continuer.",
		"isAlreadyTranslated": true
	},
	"Forgot Password?": {
		"text": "Mot de passe oublié ?",
		"isAlreadyTranslated": true
	},
	"sign in": {
		"text": "se connecter",
		"isAlreadyTranslated": true
	},
	"View Transaction Summary": {
		"text": "Afficher le résumé des transactions",
		"isAlreadyTranslated": true
	},
	"Transaction Summary": {
		"text": "Résumé des transactions",
		"isAlreadyTranslated": true
	},
	"Select Category": {
		"text": "Sélectionnez la catégorie",
		"isAlreadyTranslated": true
	},
	"Price": {
		"text": "Prix",
		"isAlreadyTranslated": true
	},
	"Check Eligibility": {
		"text": "Vérifier l'éligibilité",
		"isAlreadyTranslated": true
	},
	"Select Plans": {
		"text": "Sélectionnez les forfaits",
		"isAlreadyTranslated": true
	},
	"Transaction Status": {
		"text": "Statut de la transaction",
		"isAlreadyTranslated": true
	},
	"completed": {
		"text": "Complété",
		"isAlreadyTranslated": true
	},
	"Pending": {
		"text": "En attente",
		"isAlreadyTranslated": true
	},
	"Failed": {
		"text": "Échoué",
		"isAlreadyTranslated": true
	},
	"Report is empty.": {
		"text": "Le rapport est vide.",
		"isAlreadyTranslated": true
	},
	"Plan": {
		"text": "plan",
		"isAlreadyTranslated": true
	},
	"Invoice": {
		"text": "Facture",
		"isAlreadyTranslated": true
	},
	"Alternative Mobile No": {
		"text": "Numéro de mobile alternatif",
		"isAlreadyTranslated": true
	},
	"Brands": {
		"text": "marques",
		"isAlreadyTranslated": true
	},
	"Products": {
		"text": "produits",
		"isAlreadyTranslated": true
	},
	"Device is eligible!": {
		"text": "L'appareil est éligible !",
		"isAlreadyTranslated": true
	},
	"Device is eligible for multiple plans. Please choose a plan.": {
		"text": "L'appareil est éligible à plusieurs forfaits. Veuillez choisir un forfait.",
		"isAlreadyTranslated": true
	},
	"Verify Device": {
		"text": "Vérifier l’appareil.",
		"isAlreadyTranslated": true
	},
	"Order Summary": {
		"text": "Récapitulatif de la commande",
		"isAlreadyTranslated": true
	},
	"Rate": {
		"text": "Taux",
		"isAlreadyTranslated": true
	},
	"Total": {
		"text": "Total",
		"isAlreadyTranslated": true
	},
	"Go to Transaction Summary": {
		"text": "Aller au résumé des transactions",
		"isAlreadyTranslated": true
	},
	"Please do not close the window or press the back button.": {
		"text": "Veuillez ne pas fermer la fenêtre ni appuyer sur le bouton de retour.",
		"isAlreadyTranslated": true
	},
	"Congratulations! Your device is eligible for this plan": {
		"text": "Félicitations! Votre appareil est éligible à ce forfait",
		"isAlreadyTranslated": true
	},
	"This Device is Eligible for this Plan": {
		"text": "Cet appareil est éligible à ce plan",
		"isAlreadyTranslated": true
	},
	"Validity": {
		"text": "validité",
		"isAlreadyTranslated": true
	},
	"Price of Plan": {
		"text": "Prix du forfait",
		"isAlreadyTranslated": true
	},
	"Transaction Details": {
		"text": "Details de Transaction",
		"isAlreadyTranslated": true
	},
	"Continue": {
		"text": "Continuer",
		"isAlreadyTranslated": true
	},
	"Please enter correct Email ID": {
		"text": "Veuillez saisir l'identifiant de messagerie correct",
		"isAlreadyTranslated": true
	},
	"Please enter correct Mobile No": {
		"text": "Veuillez saisir le numéro de portable correct",
		"isAlreadyTranslated": true
	},
	"Product Details": {
		"text": "détails du produit",
		"isAlreadyTranslated": true
	},
	"Product Purchase Date": {
		"text": "Date d'achat du produit",
		"isAlreadyTranslated": true
	},
	"Plan Details": {
		"text": "Détails du forfait",
		"isAlreadyTranslated": true
	},
	"Plan Price": {
		"text": "Prix ​​du forfait",
		"isAlreadyTranslated": true
	},
	"Sales Location": {
		"text": "Lieu de vente",
		"isAlreadyTranslated": true
	},
	"Apologies! It seems we are experiencing some trouble but our team is working to fix it. Please try again in some time or contact our support team": {
		"text": "Excuses! Il semble que nous rencontrions des problèmes, mais notre équipe s'efforce de les résoudre. Veuillez réessayer dans quelques temps ou contacter notre équipe d'assistance",
		"isAlreadyTranslated": true
	},
	"This device is already registered under the desired plan": {
		"text": "Cet appareil est déjà enregistré sous le forfait souhaité",
		"isAlreadyTranslated": true
	},
	"Search": {
		"text": "Rechercher",
		"isAlreadyTranslated": true
	},
	"Billing Details": {
		"text": "Détails de facturation",
		"isAlreadyTranslated": true
	},
	"Coverage Type": {
		"text": "Type de couverture",
		"isAlreadyTranslated": true
	},
	"Are you sure you want to cancel the order?": {
		"text": "Êtes-vous certain de vouloir annuler cette commande ?",
		"isAlreadyTranslated": true
	},
	"Plan Sales Report": {
		"text": "Rapport sur les ventes de plans",
		"isAlreadyTranslated": true
	},
	"Reports": {
		"text": "Rapports",
		"isAlreadyTranslated": true
	},
	"Payment pending": {
		"text": "Paiement en attente",
		"isAlreadyTranslated": true
	},
	"Payment Pending": {
		"text": "Paiement en attente",
		"isAlreadyTranslated": true
	},
	"Send payment link": {
		"text": "Envoyer le lien de paiement",
		"isAlreadyTranslated": true
	},
	"Jan": {
		"text": "Jan",
		"isAlreadyTranslated": true
	},
	"Feb": {
		"text": "Fév",
		"isAlreadyTranslated": true
	},
	"Mar": {
		"text": "Mar",
		"isAlreadyTranslated": true
	},
	"Apr": {
		"text": "Avr",
		"isAlreadyTranslated": true
	},
	"May": {
		"text": "Mai",
		"isAlreadyTranslated": true
	},
	"Jun": {
		"text": "Juin",
		"isAlreadyTranslated": true
	},
	"Jul": {
		"text": "Juil",
		"isAlreadyTranslated": true
	},
	"Aug": {
		"text": "Août",
		"isAlreadyTranslated": true
	},
	"Sep": {
		"text": "Sept",
		"isAlreadyTranslated": true
	},
	"Oct": {
		"text": "Oct",
		"isAlreadyTranslated": true
	},
	"Nov": {
		"text": "Nov",
		"isAlreadyTranslated": true
	},
	"Dec": {
		"text": "Déc",
		"isAlreadyTranslated": true
	},
	"Years": {
		"text": "ans",
		"isAlreadyTranslated": true
	},
	"Active": {
		"text": "Actif",
		"isAlreadyTranslated": true
	},
	"Benefits Availed": {
		"text": "Avantages offerts",
		"isAlreadyTranslated": true
	},
	"Cancel Plan": {
		"text": "Annuler le forfait",
		"isAlreadyTranslated": true
	},
	"Change": {
		"text": "Changement",
		"isAlreadyTranslated": true
	},
	"Contract ID": {
		"text": "Numéro de contrat",
		"isAlreadyTranslated": true
	},
	"Coverage Details": {
		"text": "DÉTAILS DE LA COUVERTURE",
		"isAlreadyTranslated": true
	},
	"Coverage End Date": {
		"text": "Date de fin de couverture",
		"isAlreadyTranslated": true
	},
	"Coverage Name": {
		"text": "Nom de la couverture",
		"isAlreadyTranslated": true
	},
	"Declaration": {
		"text": "Déclaration",
		"isAlreadyTranslated": true
	},
	"Device Purchase Price": {
		"text": "Prix d'achat de l'appareil",
		"isAlreadyTranslated": true
	},
	"Diagnosed": {
		"text": "Diagnostiqué",
		"isAlreadyTranslated": true
	},
	"Documents": {
		"text": "Documents",
		"isAlreadyTranslated": true
	},
	"Downgraded": {
		"text": "Déclassé",
		"isAlreadyTranslated": true
	},
	"Download": {
		"text": "Télécharger",
		"isAlreadyTranslated": true
	},
	"Download Report": {
		"text": "Télécharger le rapport",
		"isAlreadyTranslated": true
	},
	"Enrolled": {
		"text": "Inscrit",
		"isAlreadyTranslated": true
	},
	"Enter Email ID": {
		"text": "Entrez l'identifiant de messagerie",
		"isAlreadyTranslated": true
	},
	"Expired": {
		"text": "Expiré",
		"isAlreadyTranslated": true
	},
	"Go to Home": {
		"text": "Aller à la maison",
		"isAlreadyTranslated": true
	},
	"IMEI 1": {
		"text": "IMEI1",
		"isAlreadyTranslated": true
	},
	"IMEI 2": {
		"text": "IMEI2",
		"isAlreadyTranslated": true
	},
	"Invoice Number": {
		"text": "Numéro de facture",
		"isAlreadyTranslated": true
	},
	"Make Payment": {
		"text": "Effectuer le paiement",
		"isAlreadyTranslated": true
	},
	"month": {
		"text": "mois",
		"isAlreadyTranslated": true
	},
	"No. Of Claims Allowed": {
		"text": "Nombre de réclamations autorisées",
		"isAlreadyTranslated": true
	},
	"Others": {
		"text": "Autres",
		"isAlreadyTranslated": true
	},
	"Payment details": {
		"text": "Détails de paiement",
		"isAlreadyTranslated": true
	},
	"Payment Details": {
		"text": "Détails de paiement",
		"isAlreadyTranslated": true
	},
	"Payment Gateway Transaction ID": {
		"text": "ID de transaction de la passerelle de paiement",
		"isAlreadyTranslated": true
	},
	"Plan Activation Date": {
		"text": "Date d'activation du forfait",
		"isAlreadyTranslated": true
	},
	"Plan Code": {
		"text": "Code du régime",
		"isAlreadyTranslated": true
	},
	"Plan Creation Date": {
		"text": "Date de création du régime",
		"isAlreadyTranslated": true
	},
	"Plan Purchase Date": {
		"text": "Date d'achat du plan",
		"isAlreadyTranslated": true
	},
	"Plan Term": {
		"text": "Durée du régime",
		"isAlreadyTranslated": true
	},
	"Policy ID": {
		"text": "ID de stratégie",
		"isAlreadyTranslated": true
	},
	"Product Category": {
		"text": "Catégorie de produit",
		"isAlreadyTranslated": true
	},
	"Purchased": {
		"text": "Acheté",
		"isAlreadyTranslated": true
	},
	"Refunded": {
		"text": "Remboursé",
		"isAlreadyTranslated": true
	},
	"Registered": {
		"text": "Inscrit",
		"isAlreadyTranslated": true
	},
	"Requested Reports": {
		"text": "Rapports demandés",
		"isAlreadyTranslated": true
	},
	"Resend Link": {
		"text": "Renvoyer le lien",
		"isAlreadyTranslated": true
	},
	"Resend Payment Link": {
		"text": "Renvoyer le lien de paiement",
		"isAlreadyTranslated": true
	},
	"Retailer Margin": {
		"text": "Marge du détaillant",
		"isAlreadyTranslated": true
	},
	"Sales Channel": {
		"text": "Canal de vente",
		"isAlreadyTranslated": true
	},
	"Select All": {
		"text": "Tout sélectionner",
		"isAlreadyTranslated": true
	},
	"Select Report Type": {
		"text": "Sélectionnez le type de rapport",
		"isAlreadyTranslated": true
	},
	"Terms and Conditions": {
		"text": "Termes et conditions",
		"isAlreadyTranslated": true
	},
	"Used Claims": {
		"text": "Allégations utilisées",
		"isAlreadyTranslated": true
	},
	"Payment Options": {
		"text": "Options de paiement",
		"isAlreadyTranslated": true
	},
	"Pay Upfront": {
		"text": "Payer d'avance",
		"isAlreadyTranslated": true
	},
	"Subscription Payment": {
		"text": "Paiement de l'abonnement",
		"isAlreadyTranslated": true
	},
	"Purchase Details": {
		"text": "Détails d'achat",
		"isAlreadyTranslated": true
	},
	"Review Details": {
		"text": "Détails de l'examen",
		"isAlreadyTranslated": true
	},
	"Purchase Confirmation": {
		"text": "Confirmation d'achat",
		"isAlreadyTranslated": true
	},
	"Enter Full Name": {
		"text": "Entrez le nom complet",
		"isAlreadyTranslated": true
	},
	"Plan Sales": {
		"text": "Souscriptions",
		"isAlreadyTranslated": true
	},
	"Store Location": {
		"text": "Emplacement magasin",
		"isAlreadyTranslated": true
	},
	"Total Sales Value": {
		"text": "Valeur totale des ventes",
		"isAlreadyTranslated": true
	},
	"Upfront Payment": {
		"text": "Paiement initial",
		"isAlreadyTranslated": true
	},
	"This includes transaction values associated with plan sales and recurring payments post activation": {
		"text": "Cela inclut les valeurs de transaction associées aux ventes du plan et aux paiements récurrents après l'activation.",
		"isAlreadyTranslated": true
	},
	"Total Earnings": {
		"text": "Gains totaux",
		"isAlreadyTranslated": true
	},
	"This includes retailer margin values associated with plan sales and recurring payments post activation": {
		"text": "Cela inclut les valeurs de marge du détaillant associées aux ventes du plan et aux paiements récurrents après l'activation.",
		"isAlreadyTranslated": true
	},
	"Number of Sales": {
		"text": "Nombre de ventes",
		"isAlreadyTranslated": true
	},
	"This includes all plan sales transactions except those contracts where customer has not completed the payment via link": {
		"text": "Cela inclut toutes les transactions de vente de plans, à l'exception des contrats pour lesquels le client n'a pas effectué le paiement via un lien.",
		"isAlreadyTranslated": true
	},
	"Total Recurring Payments": {
		"text": "Total des paiements récurrents",
		"isAlreadyTranslated": true
	},
	"This includes all successful recurring transactions associated with subscription plans": {
		"text": "Cela inclut toutes les transactions récurrentes réussies associées aux plans d'abonnement",
		"isAlreadyTranslated": true
	},
	"Payment Link Transactions": {
		"text": "Transactions de lien de paiement",
		"isAlreadyTranslated": true
	},
	"Plan Sales Summary": {
		"text": "Récapitulatif des ventes du plan",
		"isAlreadyTranslated": true
	},
	"Showing Results For": {
		"text": "Affichage des résultats pour",
		"isAlreadyTranslated": true
	},
	"Last 15 Days": {
		"text": "Les 15 derniers jours",
		"isAlreadyTranslated": true
	},
	"Custom Date": {
		"text": "Date personnalisée",
		"isAlreadyTranslated": true
	},
	"View All Transactions": {
		"text": "Afficher toutes les transactions",
		"isAlreadyTranslated": true
	},
	"Sell Plan": {
		"text": "Plan de vente",
		"isAlreadyTranslated": true
	},
	"You can only select a range within 30 days": {
		"text": "Vous ne pouvez sélectionner une plage que dans les 30 jours",
		"isAlreadyTranslated": true
	},
	"All Transactions": {
		"text": "toutes transactions",
		"isAlreadyTranslated": true
	},
	"Sorry, No Upfront Payment Transactions Found": {
		"text": "Désolé, aucune transaction de paiement initial trouvée",
		"isAlreadyTranslated": true
	},
	"Payment Plan": {
		"text": "Plan de paiement",
		"isAlreadyTranslated": true
	},
	"Sorry, No Subscription Payment Transactions Found": {
		"text": "Désolé, aucune transaction de paiement d'abonnement trouvée",
		"isAlreadyTranslated": true
	},
	"Sorry, No Transactions Found": {
		"text": "Désolé, aucune transaction trouvée",
		"isAlreadyTranslated": true
	},
	"Sorry, No Documents Found": {
		"text": "Désolé, aucun document trouvé",
		"isAlreadyTranslated": true
	},
	"More Filters": {
		"text": "Plus de filtres",
		"isAlreadyTranslated": true
	},
	"Clear All": {
		"text": "Tout effacer",
		"isAlreadyTranslated": true
	},
	"Transaction Date": {
		"text": "Date de la transaction",
		"isAlreadyTranslated": true
	},
	"Transaction Amount": {
		"text": "Montant de la transaction",
		"isAlreadyTranslated": true
	},
	"Contract Status": {
		"text": "Statut du contrat",
		"isAlreadyTranslated": true
	},
	"On Hold": {
		"text": "En attente",
		"isAlreadyTranslated": true
	},
	"Cancellation Initiated": {
		"text": "Annulation initiée",
		"isAlreadyTranslated": true
	},
	"Bundled": {
		"text": "Regroupé",
		"isAlreadyTranslated": true
	},
	"Under Review": {
		"text": "À l'étude",
		"isAlreadyTranslated": true
	},
	"Transaction Completion Date": {
		"text": "Date de réalisation de la transaction",
		"isAlreadyTranslated": true
	},
	"Payment Link Status": {
		"text": "Statut du lien de paiement",
		"isAlreadyTranslated": true
	},
	"Residential State": {
		"text": "État résidentiel",
		"isAlreadyTranslated": true
	},
	"Residential Country": {
		"text": "Pays résidentiel",
		"isAlreadyTranslated": true
	},
	"Waiting Period": {
		"text": "Temps d'attente",
		"isAlreadyTranslated": true
	},
	"Plan Cancellation Initiation Date": {
		"text": "Date de début de l’annulation du plan",
		"isAlreadyTranslated": true
	},
	"Plan Cancellation Date": {
		"text": "Date d'annulation du plan",
		"isAlreadyTranslated": true
	},
	"Cancellation Reason Description": {
		"text": "Description du motif de l'annulation",
		"isAlreadyTranslated": true
	},
	"Claim Avail Date": {
		"text": "Date de disponibilité de la réclamation",
		"isAlreadyTranslated": true
	},
	"External Payment ID": {
		"text": "ID de paiement externe",
		"isAlreadyTranslated": true
	},
	"Billed Date": {
		"text": "Date de facturation",
		"isAlreadyTranslated": true
	},
	"Billed Date (UTC)": {
		"text": "Date de facturation (UTC)",
		"isAlreadyTranslated": true
	},
	"Billing Cycle Date": {
		"text": "Date du cycle de facturation",
		"isAlreadyTranslated": true
	},
	"Billing Cycle Date (UTC)": {
		"text": "Date du cycle de facturation (UTC)",
		"isAlreadyTranslated": true
	},
	"Grace Period End Date": {
		"text": "Date de fin du délai de grâce",
		"isAlreadyTranslated": true
	},
	"Transaction ID": {
		"text": "identifiant de transaction",
		"isAlreadyTranslated": true
	},
	"Transaction Date (UTC)": {
		"text": "Date de transaction (UTC)",
		"isAlreadyTranslated": true
	},
	"Overview": {
		"text": "APERÇU",
		"isAlreadyTranslated": true
	},
	"Su": {
		"text": "Di",
		"isAlreadyTranslated": true
	},
	"Mo": {
		"text": "Lu",
		"isAlreadyTranslated": true
	},
	"Tu": {
		"text": "Ma",
		"isAlreadyTranslated": true
	},
	"We": {
		"text": "Me",
		"isAlreadyTranslated": true
	},
	"Th": {
		"text": "Je",
		"isAlreadyTranslated": true
	},
	"Fr": {
		"text": "Ve",
		"isAlreadyTranslated": true
	},
	"Sa": {
		"text": "Sa",
		"isAlreadyTranslated": true
	},
	"Protection Plans": {
		"text": "Plans de protection",
		"isAlreadyTranslated": true
	},
	"Copyright © 2015-2024 Service Lee Technologies Pvt Ltd. All rights reserved.": {
		"text": "Copyright © 2015-2024 Service Lee Technologies Pvt Ltd. Tous droits réservés.",
		"isAlreadyTranslated": true
	},
	"More": {
		"text": "Plus",
		"isAlreadyTranslated": true
	},
	"of": {
		"text": "sur",
		"isAlreadyTranslated": true
	},
	"The contract is pending for activation because payment is pending by the retailer": {
		"text": "Le contrat est en attente d'activation car le paiement est en attente par le détaillant",
		"isAlreadyTranslated": true
	},
	"The contract has been activated": {
		"text": "Le contrat a été activé",
		"isAlreadyTranslated": true
	},
	"Yearly": {
		"text": "ANNUEL",
		"isAlreadyTranslated": true
	},
	"Monthly": {
		"text": "MENSUEL",
		"isAlreadyTranslated": true
	},
	"Payment Link Transaction": {
		"text": "Transaction de lien de paiement",
		"isAlreadyTranslated": true
	},
	"Success! Payment Link Sent.": {
		"text": "félicitation! Lien de paiement envoyé.",
		"isAlreadyTranslated": true
	},
	"Success!": {
		"text": "félicitation!",
		"isAlreadyTranslated": true
	},
	"Insurance Product Information Document": {
		"text": "Document d'information sur le produit d'assurance",
		"isAlreadyTranslated": true
	},
	"Terms and Conditions Document": {
		"text": "Document de conditions générales",
		"isAlreadyTranslated": true
	},
	"Product Information Sheet": {
		"text": "Fiche d'informations sur le produit",
		"isAlreadyTranslated": true
	},
	"Information to Insurance Intermediary": {
		"text": "Informations à l'intermédiaire d'assurance",
		"isAlreadyTranslated": true
	},
	"Select Location": {
		"text": "Sélectionnez l'emplacement",
		"isAlreadyTranslated": true
	},
	"To see the list, type the first three characters.": {
		"text": "Pour voir la liste, saisissez les trois premiers caractères.",
		"isAlreadyTranslated": true
	},
	"Smartphones": {
		"text": "Smartphones",
		"isAlreadyTranslated": true
	},
	"Tablets": {
		"text": "Tablettes",
		"isAlreadyTranslated": true
	},
	"Smart Watches": {
		"text": "Montres connectées",
		"isAlreadyTranslated": true
	},
	"Streaming Devices": {
		"text": "Périphériques de streaming",
		"isAlreadyTranslated": true
	},
	"Monitors": {
		"text": "Moniteurs",
		"isAlreadyTranslated": true
	},
	"Laptops": {
		"text": "Ordinateurs portables",
		"isAlreadyTranslated": true
	},
	"Desktops (All-in-One)": {
		"text": "Ordinateurs de bureau (tout-en-un)",
		"isAlreadyTranslated": true
	},
	"Apple Plans": {
		"text": "Forfaits Apple",
		"isAlreadyTranslated": true
	},
	"Ongoing until cancelled": {
		"text": "En cours jusqu'à annulation",
		"isAlreadyTranslated": true
	},
	"Congratulations! Your device is eligible for this plan.": {
		"text": "Toutes nos félicitations! Votre appareil est éligible à ce forfait.",
		"isAlreadyTranslated": true
	},
	"Year": {
		"text": "an",
		"isAlreadyTranslated": true
	},
	"Enter Mobile ID": {
		"text": "Entrez l'identifiant mobile",
		"isAlreadyTranslated": true
	},
	"External Transaction ID": {
		"text": "ID de transaction externe",
		"isAlreadyTranslated": true
	},
	"Enter External Transaction ID": {
		"text": "Saisissez l'ID de transaction externe",
		"isAlreadyTranslated": true
	},
	"Bill Details": {
		"text": "Détails de la facture",
		"isAlreadyTranslated": true
	},
	"Base Price": {
		"text": "Prix ​​de base",
		"isAlreadyTranslated": true
	},
	"IPT": {
		"text": "IPT",
		"isAlreadyTranslated": true
	},
	"I have explained the plan Terms and Conditions to the customer and the same will be emailed to the customer on registered contact details": {
		"text": "J'ai expliqué les conditions générales du plan au client et celles-ci seront envoyées par e-mail au client aux coordonnées enregistrées.",
		"isAlreadyTranslated": true
	},
	"Paid in Store": {
		"text": "Payé en magasin",
		"isAlreadyTranslated": true
	},
	"Pay in easy installments": {
		"text": "Payez en plusieurs versements faciles",
		"isAlreadyTranslated": true
	},
	"Contract purchase date cannot be a future date": {
		"text": "La date d'achat du contrat ne peut pas être une date ultérieure",
		"isAlreadyTranslated": true
	},
	"Filter Type": {
		"text": "Type de filtre",
		"isAlreadyTranslated": true
	},
	"No results found": {
		"text": "Aucun résultat trouvé",
		"isAlreadyTranslated": true
	},
	"Please enter a OTP": {
		"text": "Veuillez saisir un OTP",
		"isAlreadyTranslated": true
	},
	"Resending OTP": {
		"text": "Renvoi d'OTP",
		"isAlreadyTranslated": true
	},
	"Transaction Start Date": {
		"text": "Date de début de la transaction",
		"isAlreadyTranslated": true
	},
	"Transaction End Date": {
		"text": "Date de fin de transaction",
		"isAlreadyTranslated": true
	},
	"Payment Initiated": {
		"text": "Paiement initié",
		"isAlreadyTranslated": true
	},
	"Cancellation Option": {
		"text": "Option d'annulation",
		"isAlreadyTranslated": true
	},
	"The customer will receive a confirmation shortly.": {
		"text": "Le client recevra une confirmation sous peu.",
		"isAlreadyTranslated": true
	},
	"Verify your account": {
		"text": "Vérifiez votre compte",
		"isAlreadyTranslated": true
	},
	"Please enter the verification code sent on this email ID": {
		"text": "Veuillez saisir le code de vérification envoyé sur cet identifiant e-mail",
		"isAlreadyTranslated": true
	},
	"Deferred Cancellation": {
		"text": "Annulation différée",
		"isAlreadyTranslated": true
	},
	"Immediate Cancellation": {
		"text": "Annulation immédiate",
		"isAlreadyTranslated": true
	},
	"The product will be covered until the last day of the current billing period. Contract will be cancelled at the end of the current billing period.": {
		"text": "Le produit sera couvert jusqu'au dernier jour de la période de facturation en cours. Le contrat sera annulé à la fin de la période de facturation en cours.",
		"isAlreadyTranslated": true
	},
	"The contract will be cancelled immediately, and the product will no longer be protected. Any applicable refund will be credited back to the original payment source.": {
		"text": "Le contrat sera immédiatement annulé et le produit ne sera plus protégé. Tout remboursement applicable sera crédité sur la source de paiement d'origine.",
		"isAlreadyTranslated": true
	},
	"Reason for Cancellation": {
		"text": "Raison pour l'annulation",
		"isAlreadyTranslated": true
	},
	"DOA / Device Failure": {
		"text": "DOA / Panne de périphérique",
		"isAlreadyTranslated": true
	},
	"Customer Remorse": {
		"text": "Remords du client",
		"isAlreadyTranslated": true
	},
	"Order input error": {
		"text": "Erreur de saisie de la commande",
		"isAlreadyTranslated": true
	},
	"Device Upgrade": {
		"text": "Mise à niveau de l'appareil",
		"isAlreadyTranslated": true
	},
	"Non-Payment MRC": {
		"text": "MRC pour non-paiement",
		"isAlreadyTranslated": true
	},
	"Cancel Contract": {
		"text": "Annuler le contrat",
		"isAlreadyTranslated": true
	},
	"View All": {
		"text": "Tout afficher",
		"isAlreadyTranslated": true
	},
	"Print Hard Copy": {
		"text": "Imprimer une copie papier",
		"isAlreadyTranslated": true
	},
	"Are you sure for cancellation?": {
		"text": "Êtes-vous sûr de l'annulation ?",
		"isAlreadyTranslated": true
	},
	"Plan Purchased Date": {
		"text": "Date d'achat du forfait",
		"isAlreadyTranslated": true
	},
	"Powered By": {
		"text": "Alimenté par",
		"isAlreadyTranslated": true
	},
	"Please enter a minimum of {{x}} digits and a maximum of {{x}} digits for {{XXX}}.": {
		"text": "Veuillez saisir un minimum de {{x}} chiffres et un maximum de {{x}} chiffres pour {{XXX}}.",
		"isAlreadyTranslated": true
	},
	"Price Summary": {
		"text": "Résumé des prix",
		"isAlreadyTranslated": true
	},
	"Version": {
		"text": "Version",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Smartphones category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Smartphones. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product's serial number / IMEI has been validated and it seems to belong to a different category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à une autre catégorie. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Tablets category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Tablettes. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Smart Watches category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Montres connectées. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Streaming Devices category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Périphériques de streaming. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Monitors category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Moniteurs. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Laptops category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Ordinateurs portables. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Desktops (All-in-One) category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Ordinateurs de bureau (tout-en-un). Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Audio Products category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Produits audio. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"The product’s serial number / IMEI has been validated and it seems to belong to Headphones / Earphones category. Please note that the plans will be suggested based on this validation.": {
		"text": "Le numéro de série/IMEI du produit a été validé et il semble appartenir à la catégorie Casques audio / Écouteurs. Veuillez noter que les plans seront proposés en fonction de cette validation.",
		"isAlreadyTranslated": true
	},
	"Enter": {
		"text": "Entrer",
		"isAlreadyTranslated": true
	},
	"optional": {
		"text": "facultatif",
		"isAlreadyTranslated": true
	},
	"Optional": {
		"text": "facultatif",
		"isAlreadyTranslated": true
	},
	"Eligible Plan(s)": {
		"text": "Plan(s) éligible(s)",
		"isAlreadyTranslated": true
	},
	"Select payment plan": {
		"text": "Sélectionnez le plan de paiement",
		"isAlreadyTranslated": true
	},
	"Plan is already active against this device": {
		"text": "Le plan est déjà actif sur cet appareil",
		"isAlreadyTranslated": true
	},
	"Please enter Reference Value": {
		"text": "Veuillez saisir la valeur de référence",
		"isAlreadyTranslated": true
	},
	"Change Payment Plan": {
		"text": "Modifier le plan de paiement",
		"isAlreadyTranslated": true
	},
	"Disclaimer: Total is rounded off to the nearest value": {
		"text": "Avertissement : Le total est arrondi à la valeur la plus proche",
		"isAlreadyTranslated": true
	},
	"Link sent to": {
		"text": "Lien envoyé à",
		"isAlreadyTranslated": true
	},
	"Payment Link Sent": {
		"text": "Lien de paiement envoyé",
		"isAlreadyTranslated": true
	},
	"Payment Link Resent": {
		"text": "Lien de paiement renvoyé",
		"isAlreadyTranslated": true
	},
	"The Contract activation is pending due to pending payment": {
		"text": "L'activation du contrat est en attente en raison d'un paiement en attente",
		"isAlreadyTranslated": true
	},
	"Information about Insurance Mediator": {
		"text": "Informations sur le Médiateur en Assurances",
		"isAlreadyTranslated": true
	},
	"Choose a Reason from the dropdown": {
		"text": "Choisissez une raison dans la liste déroulante",
		"isAlreadyTranslated": true
	},
	"Your cancellation request is accepted": {
		"text": "Votre demande d'annulation est acceptée",
		"isAlreadyTranslated": true
	},
	"You'll receive a confirmation shortly": {
		"text": "Vous recevrez une confirmation sous peu",
		"isAlreadyTranslated": true
	},
	"Back to Home": {
		"text": "Retour à la maison",
		"isAlreadyTranslated": true
	},
	"Select reason for cancellation": {
		"text": "Sélectionnez le motif de l'annulation",
		"isAlreadyTranslated": true
	},
	"Cancel Order": {
		"text": "annuler la commande",
		"isAlreadyTranslated": true
	},
	"Order Cancelled": {
		"text": "Commande annulée",
		"isAlreadyTranslated": true
	},
	"View Contract Details": {
		"text": "Afficher les détails du contrat",
		"isAlreadyTranslated": true
	},
	"Partner Name": {
		"text": "Nom du partenaire",
		"isAlreadyTranslated": true
	},
	"Plan Expiry Date": {
		"text": "Date d'expiration du plan",
		"isAlreadyTranslated": true
	},
	"User Name": {
		"text": "Nom d'utilisateur",
		"isAlreadyTranslated": true
	},
	"Terms&Conditions": {
		"text": "Conditions générales",
		"isAlreadyTranslated": true
	},
	"Coverage validity starts on": {
		"text": "La validité de la couverture commence le",
		"isAlreadyTranslated": true
	},
	"Coverage validity ends on": {
		"text": "La validité de la couverture prend fin le",
		"isAlreadyTranslated": true
	},
	"Claim can be filed from": {
		"text": "La réclamation peut être déposée à partir de",
		"isAlreadyTranslated": true
	},
	"Product Purchase Price": {
		"text": "Prix ​​d'achat du produit",
		"isAlreadyTranslated": true
	},
	"Protected": {
		"text": "Protégé",
		"isAlreadyTranslated": true
	},
	"Search by IMEI/Serial Number": {
		"text": "Recherche par IMEI/numéro de série",
		"isAlreadyTranslated": true
	},
	"View Details": {
		"text": "Voir les détails",
		"isAlreadyTranslated": true
	},
	"No Data Found": {
		"text": "Aucune donnée trouvée",
		"isAlreadyTranslated": true
	},
	"No data found": {
		"text": "Aucune donnée trouvée",
		"isAlreadyTranslated": true
	},
	"Claim History": {
		"text": "Historique des réclamations",
		"isAlreadyTranslated": true
	},
	"Claim Reference ID": {
		"text": "ID de référence de la réclamation",
		"isAlreadyTranslated": true
	},
	"Claimed Device": {
		"text": "Appareil revendiqué",
		"isAlreadyTranslated": true
	},
	"Claim Request Date": {
		"text": "Date de la demande de réclamation",
		"isAlreadyTranslated": true
	},
	"Claim Approved Date": {
		"text": "Date d'approbation de la réclamation",
		"isAlreadyTranslated": true
	},
	"Claim Status": {
		"text": "Statut de la réclamation",
		"isAlreadyTranslated": true
	},
	"No Documents available": {
		"text": "Aucun document disponible",
		"isAlreadyTranslated": true
	},
	"No documents available": {
		"text": "Aucun document disponible",
		"isAlreadyTranslated": true
	},
	"No Documents Available": {
		"text": "Aucun document disponible",
		"isAlreadyTranslated": true
	},
	"Sold Plan Document": {
		"text": "Document du plan vendu",
		"isAlreadyTranslated": true
	},
	"Payment Completed": {
		"text": "Paiement terminé",
		"isAlreadyTranslated": true
	},
	"Billing Scheduled": {
		"text": "Facturation planifiée",
		"isAlreadyTranslated": true
	},
	"Payment Failed": {
		"text": "Paiement échoué",
		"isAlreadyTranslated": true
	},
	"Billing Stopped": {
		"text": "Facturation arrêtée",
		"isAlreadyTranslated": true
	},
	"Accidental Damage": {
		"text": "Dommages accidentels",
		"isAlreadyTranslated": true
	},
	"Accidental & Liquid Damage Protection": {
		"text": "Protection contre les dommages accidentels et liquides",
		"isAlreadyTranslated": true
	},
	"Upfront": {
		"text": "En avance",
		"isAlreadyTranslated": true
	},
	"Search Store Location Name": {
		"text": "Rechercher le nom de l'emplacement du magasin",
		"isAlreadyTranslated": true
	},
	"Store Location Name": {
		"text": "Nom de l'emplacement du magasin",
		"isAlreadyTranslated": true
	},
	"Enter minimum 3 characters to search": {
		"text": "Entrez au moins 3 caractères pour rechercher",
		"isAlreadyTranslated": true
	},
	"Sorry, we couldn't find the store you're looking for": {
		"text": "Désolé, nous n'avons pas trouvé le magasin que vous recherchez",
		"isAlreadyTranslated": true
	},
	"Copyright": {
		"text": "Droit d'auteur",
		"isAlreadyTranslated": true
	},
	"All rights reserved.": {
		"text": "Tous droits réservés.",
		"isAlreadyTranslated": true
	},
	"Also known as Servify.": {
		"text": "Également connu sous le nom de Servify.",
		"isAlreadyTranslated": true
	},
	"months": {
		"text": "Mois",
		"isAlreadyTranslated": true
	},
	"Subscription plan, cancel anytime": {
		"text": "Plan d'abonnement, annulez à tout moment",
		"isAlreadyTranslated": true
	},
	"Oops! Looks like there are no plans available for this device": {
		"text": "Oops! Il semble qu'aucun forfait ne soit disponible pour cet appareil",
		"isAlreadyTranslated": true
	},
	"Promoter ID": {
		"text": "ID du promoteur",
		"isAlreadyTranslated": true
	},
	"Please enter Promoter ID": {
		"text": "Por favor ingrese el ID del promotor",
		"isAlreadyTranslated": true
	},
	"Enter Promoter ID": {
		"text": "Saisir l'ID du promoteur",
		"isAlreadyTranslated": true
	},
	"Change Location": {
		"text": "Changer d'emplacement",
		"isAlreadyTranslated": true
	},
	"User Details": {
		"text": "Détails de l'utilisateur",
		"isAlreadyTranslated": true
	},
	"Transaction Number": {
		"text": "Numéro de transaction",
		"isAlreadyTranslated": true
	},
	"Activated": {
		"text": "Activé",
		"isAlreadyTranslated": true
	},
	"Product details are unavailable": {
		"text": "Les détails du produit ne sont pas disponibles",
		"isAlreadyTranslated": true
	},
	"Sorry, no payment gateway identified. Please contact the administrator to complete the transaction": {
		"text": "Désolé, aucune passerelle de paiement identifiée. Veuillez contacter l'administrateur pour finaliser la transaction",
		"isAlreadyTranslated": true
	},
	"Filter Reports": {
		"text": "Filtrer les rapports",
		"isAlreadyTranslated": true
	},
	"Payment Due & Overdue for Recurring Billing Report": {
		"text": "Paiement dû et en retard pour le rapport de facturation récurrente",
		"isAlreadyTranslated": true
	},
	"Sales and Cancellation Report - Internal": {
		"text": "Rapport de ventes et d'annulations - Interne",
		"isAlreadyTranslated": true
	},
	"Payment Due & Overdue for Recurring Billing Report - Internal": {
		"text": "Paiement dû et en retard pour le rapport de facturation récurrente – Interne",
		"isAlreadyTranslated": true
	},
	"Sales and Cancellation Report": {
		"text": "Rapport de ventes et d'annulation",
		"isAlreadyTranslated": true
	},
	"Recent Requested Report": {
		"text": "Rapport récemment demandé",
		"isAlreadyTranslated": true
	},
	"Report Type": {
		"text": "Type de rapport",
		"isAlreadyTranslated": true
	},
	"Report Requested On": {
		"text": "Rapport demandé le",
		"isAlreadyTranslated": true
	},
	"Download File": {
		"text": "Télécharger le fichier",
		"isAlreadyTranslated": true
	},
	"Success": {
		"text": "Succès",
		"isAlreadyTranslated": true
	},
	"Failure": {
		"text": "Échec",
		"isAlreadyTranslated": true
	},
	"Report Status": {
		"text": "Statut du rapport",
		"isAlreadyTranslated": true
	},
	"Select Store Location": {
		"text": "Sélectionnez l'emplacement du magasin",
		"isAlreadyTranslated": true
	},
	"Payment Link Sent Successfully": {
		"text": "Lien de paiement envoyé avec succès",
		"isAlreadyTranslated": true
	},
	"Address Line 1": {
		"text": "Adresse Ligne 1",
		"isAlreadyTranslated": true
	},
	"Address Line 2": {
		"text": "Ligne d'adresse 2",
		"isAlreadyTranslated": true
	},
	"Incorrect IMEI/Serial Number": {
		"text": "Numéro IMEI/série incorrect",
		"isAlreadyTranslated": true
	},
	"Please enter correct IMEI/Serial Number": {
		"text": "Veuillez saisir le bon numéro IMEI/série",
		"isAlreadyTranslated": true
	},
	"Insufficent params for updation": {
		"text": "Paramètres insuffisants pour la mise à jour",
		"isAlreadyTranslated": true
	},
	"Cancellation Request Summary": {
		"text": "Résumé de la demande d'annulation",
		"isAlreadyTranslated": true
	},
	"Effective Cancellation Date": {
		"text": "Date d'effet de l'annulation",
		"isAlreadyTranslated": true
	},
	"Total Refund Applicable": {
		"text": "Remboursement total applicable",
		"isAlreadyTranslated": true
	},
	"Refund will be processed to the original payment source within 7-10 business days.": {
		"text": "Le remboursement sera traité sur la source de paiement d'origine dans un délai de 7 à 10 jours ouvrables.",
		"isAlreadyTranslated": true
	},
	"Keep Contract": {
		"text": "Conserver le contrat",
		"isAlreadyTranslated": true
	},
	"Cancellation request has been accepted": {
		"text": "La demande d'annulation a été acceptée",
		"isAlreadyTranslated": true
	},
	"Customer will receive a confirmation on their registered details shortly.": {
		"text": "Le client recevra sous peu une confirmation de ses informations enregistrées.",
		"isAlreadyTranslated": true
	},
	"Choose a cancellation reason": {
		"text": "Choisissez une raison d'annulation",
		"isAlreadyTranslated": true
	},
	"Cancellation request has failed": {
		"text": "La demande d'annulation a échoué",
		"isAlreadyTranslated": true
	},
	"Okay": {
		"text": "D'accord",
		"isAlreadyTranslated": true
	},
	"Call Logs": {
		"text": "Journal des appels",
		"isAlreadyTranslated": true
	},
	"Calling Number": {
		"text": "Numéro d'appel",
		"isAlreadyTranslated": true
	},
	"Support Ticket Number": {
		"text": "Numéro du ticket d'assistance",
		"isAlreadyTranslated": true
	},
	"Name of the Agent": {
		"text": "Nom de l'agent",
		"isAlreadyTranslated": true
	},
	"Second Dialer Disposition": {
		"text": "Disposition du deuxième appelant",
		"isAlreadyTranslated": true
	},
	"Full Name": {
		"text": "Nom et prénom",
		"isAlreadyTranslated": true
	},
	"Send Payment Link": {
		"text": "Renvoyer le lien de paiement",
		"isAlreadyTranslated": true
	},
	"COVERAGE DETAILS": {
		"text": "DÉTAILS DE LA COUVERTURE",
		"isAlreadyTranslated": true
	},
	"DEVICE DETAILS": {
		"text": "DÉTAILS DE L'APPAREIL",
		"isAlreadyTranslated": true
	},
	"Terms and Conditions Document": {
		"text": "Document de conditions générales",
		"isAlreadyTranslated": true
	},
	"Insurance Product Information Document": {
		"text": "Document d'information sur le produit d'assurance",
		"isAlreadyTranslated": true
	},
	"Sorry, no upfront payment transactions found": {
		"text": "Désolé, aucune transaction de paiement initial trouvée",
		"isAlreadyTranslated": true
	},
	"Sorry, no subscription payment transactions found": {
		"text": "Désolé, aucune transaction de paiement d'abonnement trouvée",
		"isAlreadyTranslated": true
	},
	"Congratulations! Your product is eligible for this plan": {
		"text": "Nous vous félicitons ! Votre produit est éligible à ce plan.",
		"isAlreadyTranslated": true
	},
	"Refund Processing": {
		"text": "Traitement du remboursement",
		"isAlreadyTranslated": true
	},
	"Refund Completed": {
		"text": "Remboursement terminé",
		"isAlreadyTranslated": true
	},
	"Refund Amount": {
		"text": "Montant du remboursement",
		"isAlreadyTranslated": true
	},
	"Refund Status": {
		"text": "Statut du remboursement",
		"isAlreadyTranslated": true
	},
	"Refund Processed by": {
		"text": "Remboursement traité par",
		"isAlreadyTranslated": true
	},
	"Seller": {
		"text": "Vendeur",
		"isAlreadyTranslated": true
	},
	"Payment Due Date": {
		"text": "Date d'échéance du paiement",
		"isAlreadyTranslated": true
	},
	"Payment Requested Date": {
		"text": "Date de paiement demandée",
		"isAlreadyTranslated": true
	},
	"Payment Completion Date": {
		"text": "Date d'achèvement du paiement",
		"isAlreadyTranslated": true
	},
	"Transaction ID": {
		"text": "ID de la transaction",
		"isAlreadyTranslated": true
	},
	"External Transaction ID": {
		"text": "ID de la transaction externe",
		"isAlreadyTranslated": true
	},
	"Amount": {
		"text": "Montant",
		"isAlreadyTranslated": true
	},
	"Grace Period End Date": {
		"text": "Date de fin du délai de grâce",
		"isAlreadyTranslated": true
	},
	"Status": {
		"text": "Statut",
		"isAlreadyTranslated": true
	},
	"Retailer Margin": {
		"text": "Marge du détaillant",
		"isAlreadyTranslated": true
	},
	"Customer Invoice": {
		"text": "Facture du client",
		"isAlreadyTranslated": true
	},
	"Cancellation Initiated": {
		"text": "Annulation initiée",
		"isAlreadyTranslated": true
	},
	"Cancelled": {
		"text": "Annulée",
		"isAlreadyTranslated": true
	},
	"Cancellation request has been accepted.": {
		"text": "La demande d'annulation a été acceptée.",
		"isAlreadyTranslated": true
	},
	"Coverage ends in": {
		"text": "La couverture se termine dans",
		"isAlreadyTranslated": true
	},
	"Cancellation Pending ": {
		"text": "Annulation en attente",
		"isAlreadyTranslated": true
	},
	"This option will be available if the payment for the previous billing cycle is successfully received.": {
		"text": "Cette option sera disponible si le paiement du cycle de facturation précédent a été reçu avec succès.",
		"isAlreadyTranslated": true
	},
	"The final refund will be processed to the original payment source if the payment for the previous billing cycle is successfully received.": {
		"text": "Le remboursement final sera effectué à la source de paiement d'origine si le paiement pour le cycle de facturation précédent a été reçu avec succès.",
		"isAlreadyTranslated": true
	},
	"Cancellation request is restricted": {
		"text": "La demande d'annulation est limitée",
		"isAlreadyTranslated": true
	},
	"You will be able to cancel plan if the payment for the previous billing cycle is successfully received": {
		"text": "Vous pourrez annuler le plan si le paiement du cycle de facturation précédent a été reçu avec succès.",
		"isAlreadyTranslated": true
	},
	"Customer will receive a confirmation on their registered details shortly.": {
		"text": "El cliente recibirá una confirmación de sus datos registrados en breve.",
		"isAlreadyTranslated": true
	},
	"Deferred cancellation will be available if the payment for the previous billing cycle is successfully received.": {
		"text": "L'annulation différée sera possible si le paiement du cycle de facturation précédent a été reçu avec succès.",
		"isAlreadyTranslated": true
	},
	"This option will be available if the payment for the previous billing cycle is successfully received.": {
		"text": "Cette option sera disponible si le paiement du cycle de facturation précédent a été reçu avec succès.",
		"isAlreadyTranslated": true
	},
	"A payment link will be sent to the customer to enter a valid payment method. A temporary authorization may be used to verify it, but no charge will occur.": {
		"text": "Un lien de paiement sera envoyé au client afin qu’il puisse saisir un moyen de paiement valide. Une autorisation temporaire pourra être utilisée pour vérification, mais aucun débit ne sera effectué.",
		"isAlreadyTranslated": true
	},
	"Sales Summary Report": {
		"text": "Rapport récapitulatif des ventes",
		"isAlreadyTranslated": true
	},
	"Financial Transactions Report": {
		"text": "Rapport sur les transactions financières",
		"isAlreadyTranslated": true
	},
	"Financial Transactions Report - Internal": {
		"text": "Rapport sur les transactions financières - Interne",
		"isAlreadyTranslated": true
	},
	"Pay Via QR": {
		"text": "Payer Via QR",
		"isAlreadyTranslated": true
	},
	"Scan QR Code": {
		"text": "Scanner le code QR",
		"isAlreadyTranslated": true
  	},
	"Follow this link to complete payment for the purchase": {
		"text": "Cliquez sur ce lien pour finaliser le paiement de votre achat",
		"isAlreadyTranslated": true
	}
};
export default lang;